import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

const axios = require('axios').default;

import { ToastContainer, toast } from 'react-toastify';
import { toastError } from '../../../shared/toastHelper';
import Tippy from '@tippyjs/react';
import {
  Button,
  CalendarDate,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Keyboard01,
  List as ListIcon,
  Plus,
  Sliders01,
  Tooltip,
} from '@opendate-app/setlist';
import CalendarSearchInput from './CalendarSearchInput';

import { isMobileOnly } from 'react-device-detect';
import '../styles/calendarViewV2Styles.css';
import '../styles/calendarDarkMode.css';
import CalendarOptions from '../../CalendarOptions/components/CalendarOptions';
import AnnouncementAlert from '../../AnnouncementAlert/components/AnnouncementAlert';
import DataTable from '../../DataTable/components/DataTable';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import Popup from "reactjs-popup";
var moment = require('moment');

import CalendarEventConflictPopup from './CalendarEventConflictPopup';
import CheckAvailsPopup from './CheckAvailsPopup';
import EventForm from '../../EventForm/components/EventForm';
import CalendarSyncPopup from './CalendarSyncPopup';
import CalendarMenu from './CalendarMenu';
import SeriesPill from '../../shared/components/SeriesPill';
import { groupSameSeriesSameDayMarketingDates } from './groupSameSeriesSameDayMarketingDates';

var _ = require('lodash');
import $ from 'jquery';
require('datatables.net-bs4');

import {
  offsetDateForBrowser,
  setGonTimeZoneFromVenue
} from '../../../shared/timeZoneLogic';
import { resolveCheckAvailsRooms } from '../../../shared/checkAvailsUtils';
import ClearHoldsPopup from './ClearHoldsPopup';
import HoldReorderPopover from './HoldReorderPopover';
import HoldChallengeSummary from './HoldChallengeSummary';
import HoldChallengesMenu from './HoldChallengesMenu';
import ClearHoldModal from './ClearHoldModal';
import { canClearHold, holdRoomNames, useClearHold } from './clearHold';
import ClearHoldTrigger from './ClearHoldTrigger';
import { HOLDS_ON_DATE_ATTRIBUTE, START_CHALLENGE_ATTRIBUTE, groupActiveHoldsByDay, hasHoldAhead, holdsOnDate } from './holdsOnDate';
import { challengerSideOf, holdChallengeErrorMessage, startHoldChallenge } from '../api/holdChallengesApi';
import '../styles/clearHold.css';
import KeyboardShortcutsModal from './KeyboardShortcutsModal';
import GoToDateModal from './GoToDateModal';
import MobileEventList from './MobileEventList';
import MobileMonthCalendar from './MobileMonthCalendar';
import MobileFullCalendar from './MobileFullCalendar';
import MobileShortcutsButton from './MobileShortcutsButton';
import { MobileHoldChallengesProvider } from './MobileHoldChallenges';

const MIN_EVENT_WIDTH_DAY_VIEW = 160;
const EVENT_GAP = 8;
const COLUMN_PADDING = 16; // Horizontal padding within day column
const RESIZE_DEBOUNCE_DELAY = 50; // Delay for ResizeObserver callback (ms)
const INITIAL_CALCULATION_DELAY = 100; // Initial delay for event max stack calculation (ms)
const ROOMLESS_VENUE_ORDER = Infinity;
const GROUPED_CARD_HEADER_HEIGHT = 48;
const GROUPED_CARD_ROW_HEIGHT = 16;
const FULL_CALENDAR_VIEWS = { calendar: "dayGridMonth", calendar_weekly: "timeGridWeek", calendar_daily: "timeGridDay" };
// How far past midnight an event must run before a whole-day cell treats it as reaching the next
// day. A late-night show (11pm-2am) belongs to the night it started, so month cells stop at the
// start day instead of smearing into the next one. Mirrors the 3am rollback in
// CalendarEvent#human_rounded_end_time. Whole-day cells only, so week/day views are unaffected.
const NEXT_DAY_THRESHOLD = '03:00:00';

const formatEventTimeLine = (timeText, venueName) =>
  [timeText, venueName].filter(Boolean).join(' - ');

const formatCardTime = (timestamp) => {
  if (!timestamp) return '';

  return new Date(timestamp)
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
    .replace(/\s?([AP])M$/, (match, meridiem) => `${meridiem.toLowerCase()}m`);
};

const formatCardDate = (timestamp) => {
  if (!timestamp) return '';

  return new Date(timestamp)
    .toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const getEventTypeLabel = (classification) => {
  switch (classification) {
    case 'confirm': return 'Confirm';
    case 'announced': return 'Announced';
    case 'on_sale': return 'On Sale';
    case 'pre_sale': return 'Pre-sale';
    case 'artist_pre_sale': return 'Artist Pre-sale';
    case 'past': return 'Past';
    case 'canceled': return 'Canceled';
    case 'postponed': return 'Postponed';
    default: return 'Confirm';
  }
};

const marketingDateGroup = (info) => {
  const marketingDates = info.event.extendedProps.grouped_marketing_dates || [];

  if (!info.event.extendedProps.is_series_group || marketingDates.length === 0) {
    return null;
  }

  const title = (info.event.extendedProps.spans_multiple_events
    ? info.event.extendedProps.series_name
    : info.event.title) || info.event.title;

  return { marketingDates, title };
};

const MarketingDateRows = ({ marketingDates, eventIconPath }) => (
  <>
    {marketingDates.map((marketingDate, index) => (
      <div key={`${marketingDate.id}-${marketingDate.classification}-${index}`}
           className="d-flex align-items-center"
           style={{ marginTop: "1px" }}>
        <img src={eventIconPath({ classification: marketingDate.classification }, true)}
             style={{ width: "12px", minWidth: "12px", marginRight: "4px" }} />
        <span className="text-truncate"
              style={{ fontSize: "10px", fontWeight: "600", minWidth: 0, color: 'var(--od-c-414651, #414651)' }}>
          {getEventTypeLabel(marketingDate.classification)}
        </span>
        <span style={{ fontSize: "10px", marginLeft: "6px", flexShrink: 0, color: 'var(--od-c-414651, #414651)' }}>
          {formatCardTime(marketingDate.start || marketingDate.date)}
        </span>
      </div>
    ))}
  </>
);

const newContentStyle = {
  "border": "none",
  "overflowY": "auto",
  "overflowX": "hidden",
  "zIndex": '200',
  "pointerEvents": "auto",
  "padding": "0",
  "background": "var(--od-surface, #fff)"
}

const popupContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "200px",
  "padding": "0px"
}

const settingsContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "250px",
  "padding": "0px",
  "marginTop": "10px",
  "zIndex": "3000"
}

const calendarEventConflictsContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "650px",
  "padding": "30px",
  "background": "var(--od-surface, #fff)"
}

const checkAvailsContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "698px",
  "padding": "18px 32px",
  "background": "var(--od-surface, #fff)"
}

const calendarSyncContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "840px",
  "padding": "18px 0px",
  "background": "var(--od-surface, #fff)"
}

const datesAreOnSameDay = (firstDate, secondDate) => {
  return (
    firstDate.getFullYear() === secondDate.getFullYear()
      && firstDate.getMonth() === secondDate.getMonth()
      && firstDate.getDate() === secondDate.getDate()
  );
};

const isDateInEventRange = (dateRange, currentDate) => {
  if (dateRange.length === 1) {
    return datesAreOnSameDay(new Date(dateRange[0]), currentDate);
  }

  const normalizedCurrentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
  const eventStart = new Date(dateRange[0]);
  const normalizedEventStart = new Date(eventStart.getFullYear(), eventStart.getMonth(), eventStart.getDate());
  const eventEnd = new Date(dateRange[1]);
  const normalizedEventEnd = new Date(eventEnd.getFullYear(), eventEnd.getMonth(), eventEnd.getDate());

  return normalizedCurrentDate >= normalizedEventStart && normalizedCurrentDate <= normalizedEventEnd;
};

const getAvailableDates = (events, checkAvailsSettings, checkAvailsDates, defaultTopHold, selectedRooms) => {
  var foundDates = [];

  if (!events || !Array.isArray(events)) {
    return foundDates;
  }

  if (!checkAvailsDates || checkAvailsDates.length !== 2) {
    return foundDates;
  }

  if (!selectedRooms || selectedRooms.length === 0) {
    return foundDates;
  }

  var notCanceledEvents = events.filter((e) => e.classification !== "canceled");

  var eventsByRoom = {};
  notCanceledEvents.forEach((event) => {
    if (!eventsByRoom[event.room_id]) {
      eventsByRoom[event.room_id] = [];
    }
    eventsByRoom[event.room_id].push(event);
  });

  var startDate = checkAvailsDates[0];
  var endDate = checkAvailsDates[1];

  selectedRooms.forEach((room) => {
    var roomEvents = eventsByRoom[room.value] || [];
    var currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      var isAvailable = (
        checkAvailsSettings.onDaysOfWeek.includes(currentDate.getDay())
          && (
            !checkAvailsSettings.noConfirms
              || roomEvents
                  .filter((e) => e.type === "Confirm")
                  .filter((e) => isDateInEventRange(e.date_range, currentDate))
                  .length === 0
          )
          && (
            !checkAvailsSettings.noHolds
              || roomEvents
                  .filter((e) => e.type === "Hold")
                  .filter((e) => isDateInEventRange(e.date_range, currentDate))
                  .length === 0
          )
      );

      if (isAvailable) {
        var takenPositions = roomEvents
          .filter((e) => isDateInEventRange(e.date_range, currentDate))
          .map((e) => e.position)
          .sort((a, b) => a - b);

        var availablePosition = null;
        for (var i = defaultTopHold; i <= 20; i++) {
          if (!takenPositions.includes(i)) {
            availablePosition = i;
            break;
          }
        }

        if (availablePosition !== null) {
          foundDates.push({
            date: new Date(currentDate),
            position: availablePosition,
            roomId: room.value,
            roomName: room.label
          });
        }
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }
  });

  return foundDates;
}

const CHALLENGE_HIGHLIGHT_MS = 6000;

const HoldEvent = ({
  info,
  eventIconPath,
  canClear,
  canOpenHoldsOnDate,
  canStartChallenge
}) => {
  const room = info.event.extendedProps.room;
  const formattedDate = moment(info.event.start).format('MMM D, YYYY');
  const hexColor = room.calendar_color_hex;

  return (
    <Tippy className="calendar-view-tippy"
            content={
              <div className='row' style={{width: "232px"}}>
                <div className='col-12' style={{"fontSize": "10px"}}>
                  <div className='d-flex align-items-center'
                        style={{"marginBottom": "2px", justifyContent: "space-between"}}>
                    <div>
                      <img src={eventIconPath(info.event.extendedProps, false)}
                            style={{width: "13px", marginRight: "4px"}} />
                      <span style={{"fontSize": "12px", "fontWeight": "bold"}}>
                        Hold
                      </span>
                    </div>
                    <div>
                      {info.event.extendedProps.is_rental ? (
                        <div style={{border: "1px solid var(--od-c-ffffff, #FFFFFF)", backgroundColor: "var(--od-c-ffffff, #FFFFFF)", borderRadius: "12px", padding: "2px 4px", color: "var(--od-c-333333, #333333)"}}>
                          Rental
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <p className='mb-0 text-truncate'
                      style={{
                        marginTop: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        lineHeight: "20px"
                      }}>
                    <strong>{info.event.title}</strong>
                  </p>
                  <p className='mb-0'
                      style={{
                        color: "var(--od-tooltip-text)",
                        marginTop: "3px",
                        fontSize: "12px",
                        lineHeight: "18px"
                      }}>
                    {formattedDate}
                  </p>
                  <p className='mb-0'
                      style={{
                        color: "var(--od-tooltip-text)",
                        fontSize: "12px",
                        lineHeight: "18px"
                      }}>
                    {room.name}
                  </p>
                  <HoldChallengeSummary challenges={info.event.extendedProps.challenges} />
                </div>
              </div>
            }>
      <div className='d-flex align-items-center w-100 h-100'
            style={{
              cursor: (info.event.extendedProps.authorized ? "pointer" : "default"),
              opacity: (
                info.event.extendedProps.converted_to_confirm_at  !== null ||
                info.event.extendedProps.cleared_at
              ) ? "0.5" : "1",
            }}>
        <div style={{
                marginRight: "4px",
                padding: "2px 3px",
                borderRadius: "4px",
                border: "1px solid " + hexColor,
                borderStyle: info.event.extendedProps.is_rental ? "dashed" : "solid",
                fontSize: "10px",
                fontWeight: "bold",
                color: "var(--od-c-333333, #333)"
              }}>
          {"H" + info.event.extendedProps.position}
        </div>
        <div className="flex-grow-1 d-flex flex-column justify-content-center"
              style={{minWidth: '0'}}>
          <span className="fc-event-first-line mb-0 d-inline-block text-truncate"
              style={{
                maxWidth: "100%",
                marginRight: "0px"
              }}
              title={info.event.title}>
            {info.event.title}
          </span>
          {info.event.extendedProps.venue_name ? (
            <span className="fc-event-second-line mb-0 d-inline-block text-truncate"
                style={{ maxWidth: "100%", marginTop: "0px" }}
                title={info.event.extendedProps.venue_name}>
              {info.event.extendedProps.venue_name}
            </span>
          ) : null}
        </div>
        {info.event.extendedProps.challenges?.length > 0 ? (
          <span className="hold-event-challenge"
                {...(canOpenHoldsOnDate ? { [HOLDS_ON_DATE_ATTRIBUTE]: 'true', title: 'Holds on this date' } : {})}>
            <i className={`fas fa-bolt ${info.event.extendedProps.challenges.some((challenge) => challenge.overdue) ? 'hold-challenge-overdue' : 'hold-challenge-open'}`} />
          </span>
        ) : canStartChallenge ? (
          <span className="hold-event-challenge hold-event-challenge--hover"
                {...{ [START_CHALLENGE_ATTRIBUTE]: 'true' }}
                title="Challenge a hold ahead">
            <i className="fas fa-bolt" />
          </span>
        ) : null}
        <span className={`hold-event-icon-slot${canClear ? ' hold-event-icon-slot--clearable' : ''}`}>
          <span className="hold-event-type-icon">
            {info.event.extendedProps.is_target ? (
              <i className="fas fa-bullseye-arrow" style={{ color: hexColor }} />
            ) : (
              <img src={eventIconPath(info.event.extendedProps, true)} />
            )}
          </span>
          {canClear ? <ClearHoldTrigger /> : null}
        </span>
      </div>
    </Tippy>
  );
};

HoldEvent.propTypes = {
  info: PropTypes.object.isRequired,
  eventIconPath: PropTypes.func.isRequired,
  canClear: PropTypes.bool.isRequired,
  canOpenHoldsOnDate: PropTypes.bool.isRequired,
  canStartChallenge: PropTypes.bool.isRequired
};

const ConfirmEvent = ({
  info,
  team,
  eventIconPath
}) => {
  const hexToRGB = (hex) => {
    hex = hex.replace(/^#/, '');

    let bigint = parseInt(hex, 16);
    let r, g, b;

    if (hex.length === 3) {
      r = (bigint >> 8 & 0xF) * 17;
      g = (bigint >> 4 & 0xF) * 17;
      b = (bigint & 0xF) * 17;
    } else {
      r = (bigint >> 16) & 255;
      g = (bigint >> 8) & 255;
      b = bigint & 255;
    }

    return {
      r: r,
      g: g,
      b: b
    };
  }

  const formatTimestamp = (timestamp, monthFormat) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString('en-US', {
      month: monthFormat,
      day: 'numeric',
      year: 'numeric',
    });

    let formattedTime = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).toLowerCase();

    formattedTime = formattedTime.replace(/\s([ap]m)/, '$1');
    return `${formattedDate} - ${formattedTime}`;
  }

  const room = info.event.extendedProps.room;
  const hexColor = room.calendar_color_hex;
  const rgbColor = hexToRGB(hexColor);

  const marketingDates = marketingDateGroup(info);
  const spansMultipleEvents = !!info.event.extendedProps.spans_multiple_events;

  const holdPositionId = info.event.extendedProps.hold_position_id;
  const [hasFetchedTooltipData, setHasFetchedTooltipData] = useState(false);
  const [showActivities, setShowActivities] = useState([]);
  const [totalTicketsSold, setTotalTicketsSold] = useState(null);
  const [ticketGross, setTicketGross] = useState(null);

  const announceShowActivity = showActivities.find((sa) => sa.name === "Announce");
  const artistPreSaleShowActivity = showActivities.find((sa) => sa.name === "Artist Pre-Sale");
  const preSaleShowActivity = showActivities.find((sa) => sa.name === "Venue Pre-Sale");
  const onSaleShowActivity = showActivities.find((sa) => sa.name === "Public On-Sale");
  const startShowActivity = showActivities.find((sa) => sa.name === "Event Start");

  return (
    <Tippy className="calendar-view-tippy"
            onShow={() => {
              if(hasFetchedTooltipData) return;

              axios
                .get(`/teams/${team.id}/hold_positions/${holdPositionId}/tooltip`)
                .then(({data}) => {
                  setHasFetchedTooltipData(true);
                  setShowActivities(data.show_activities || []);
                  setTotalTicketsSold(data.total_tickets_sold ?? null);
                  setTicketGross(data.ticket_gross ?? null);
                })
                .catch(() => {
                  setHasFetchedTooltipData(true);
                  toastError("Failed to load event details");
                })
            }}
            content={
              hasFetchedTooltipData ? (
                <div className='form-row' style={{width: "265px"}}>
                  <div className='col-12' style={{"fontSize": "10px"}}>
                    <div className='d-flex align-items-center'
                          style={{"marginBottom": "2px", justifyContent: "space-between"}}>
                      {marketingDates ? (
                        <div>
                          <img src={eventIconPath({classification: "announced"}, false)}
                                style={{width: "14px", marginRight: "4px"}} />
                          <span style={{"fontSize": "12px", "fontWeight": "bold"}}>
                            Series
                          </span>
                        </div>
                      ) : info.event.extendedProps.classification === "canceled" ? (
                        <div>
                          <img src={eventIconPath({classification: "canceled"}, false)}
                                style={{width: "14px", marginRight: "4px"}} />
                          <span style={{"fontSize": "12px", "fontWeight": "bold"}}>
                            Canceled
                          </span>
                        </div>
                      ) : info.event.extendedProps.classification === "postponed" ? (
                        <div>
                          <img src={eventIconPath({classification: "postponed"}, false)}
                                style={{width: "14px", marginRight: "4px"}} />
                          <span style={{"fontSize": "12px", "fontWeight": "bold"}}>
                            Postponed
                          </span>
                        </div>
                      ) : (
                        <div>
                          <img src={eventIconPath({classification: "confirm"}, false)}
                                style={{width: "14px", marginRight: "4px"}} />
                          <span style={{"fontSize": "12px", "fontWeight": "bold"}}>
                            Confirm
                          </span>
                        </div>
                      )}
                      <div>
                        {info.event.extendedProps.is_rental ? (
                          <div style={{border: "1px solid var(--od-c-ffffff, #FFFFFF)", backgroundColor: "var(--od-c-ffffff, #FFFFFF)", borderRadius: "12px", padding: "2px 4px", color: "var(--od-c-333333, #333333)"}}>
                            Rental
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <p className='mb-0 text-truncate'
                        style={{
                          marginTop: "8px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          lineHeight: "20px"
                        }}>
                      <strong>{marketingDates ? marketingDates.title : info.event.title}</strong>
                    </p>
                    <p className='mb-0'
                        style={{
                          color: "var(--od-tooltip-text)",
                          marginTop: "3px",
                          fontSize: "12px",
                          lineHeight: "18px"
                        }}>
                      {marketingDates ? (
                        formatCardDate(info.event.start)
                      ) : startShowActivity && startShowActivity.start_time && startShowActivity.set ? (
                        formatTimestamp(startShowActivity.start_time, "long")
                      ) : (
                        <span>Not set</span>
                      )}
                    </p>
                    <p className='mb-0'
                        style={{
                          color: "var(--od-tooltip-text)",
                          fontSize: "12px",
                          lineHeight: "18px"
                        }}>
                      {room.name}
                    </p>
                  </div>
                  <div className='col-12'
                        style={{
                          "paddingTop": "10px",
                          "marginTop": "10px",
                          "borderTop": "1px solid var(--od-c-535862, #535862)"
                        }}>
                    <div className='form-row'>
                      <div className='col-12 d-flex align-items-center' style={{marginTop: "3px"}}>
                        <img src={eventIconPath({classification: "announced"}, false)}
                            style={{width: "14px", marginRight: "7px"}} />
                        <p className='mb-0' style={{"fontSize": "12px", "fontWeight": "600"}}>
                          Announce
                        </p>
                        <p className='mb-0 flex-grow-1 text-right' style={{"fontSize": "12px"}}>
                          {announceShowActivity && announceShowActivity.start_time && announceShowActivity.set ? (
                            formatTimestamp(announceShowActivity.start_time, "short")
                          ) : (
                            <span>Not set</span>
                          )}
                        </p>
                      </div>
                      {team.mode === "AGENT_MANAGER" ? (
                        <div className='col-12 d-flex align-items-center' style={{marginTop: "7px"}}>
                          <img src={eventIconPath({classification: "pre_sale"}, false)}
                              style={{width: "14px", marginRight: "7px"}} />
                          <p className='mb-0' style={{"fontSize": "12px", "fontWeight": "600"}}>
                            Artist Pre-sale
                          </p>
                          <p className='mb-0 flex-grow-1 text-right' style={{"fontSize": "12px"}}>
                            {artistPreSaleShowActivity && artistPreSaleShowActivity.start_time && artistPreSaleShowActivity.set ? (
                              formatTimestamp(artistPreSaleShowActivity.start_time, "short")
                            ) : (
                              <span>Not set</span>
                            )}
                          </p>
                        </div>
                      ) : null}
                      <div className='col-12 d-flex align-items-center' style={{marginTop: "7px"}}>
                        <img src={eventIconPath({classification: "pre_sale"}, false)}
                            style={{width: "14px", marginRight: "7px"}} />
                        <p className='mb-0' style={{"fontSize": "12px", "fontWeight": "600"}}>
                          Venue Pre-sale
                        </p>
                        <p className='mb-0 flex-grow-1 text-right' style={{"fontSize": "12px"}}>
                          {preSaleShowActivity && preSaleShowActivity.start_time && preSaleShowActivity.set ? (
                            formatTimestamp(preSaleShowActivity.start_time, "short")
                          ) : (
                            <span>Not set</span>
                          )}
                        </p>
                      </div>
                      <div className='col-12 d-flex align-items-center' style={{marginTop: "7px", "marginBottom": "6px"}}>
                        <img src={eventIconPath({classification: "on_sale"}, false)}
                            style={{width: "14px", marginRight: "7px"}} />
                        <p className='mb-0' style={{"fontSize": "12px", "fontWeight": "600"}}>
                          On sale
                        </p>
                        <p className='mb-0 flex-grow-1 text-right' style={{"fontSize": "12px"}}>
                          {onSaleShowActivity && onSaleShowActivity.start_time && onSaleShowActivity.set ? (
                            formatTimestamp(onSaleShowActivity.start_time, "short")
                          ) : (
                            <span>Not set</span>
                          )}
                        </p>
                      </div>
                      {!spansMultipleEvents && totalTicketsSold != null && (
                        <div className='col-12 d-flex align-items-center' style={{marginTop: "7px", marginBottom: "6px"}}>
                          <img src={eventIconPath({classification: "on_sale"}, false)}
                              style={{width: "14px", marginRight: "7px"}} />
                          <p className='mb-0' style={{fontSize: "12px", fontWeight: "600"}}>
                            Tickets sold
                          </p>
                          <p className='mb-0 flex-grow-1 text-right' style={{fontSize: "12px"}}>
                            {Intl.NumberFormat().format(totalTicketsSold)}
                          </p>
                        </div>
                      )}
                      {!spansMultipleEvents && ticketGross != null && (
                        <div className='col-12 d-flex align-items-center' style={{marginTop: "7px", marginBottom: "6px"}}>
                          <img src={eventIconPath({classification: "on_sale"}, false)}
                              style={{width: "14px", marginRight: "7px"}} />
                          <p className='mb-0' style={{fontSize: "12px", fontWeight: "600"}}>
                            Tickets gross
                          </p>
                          <p className='mb-0 flex-grow-1 text-right' style={{fontSize: "12px"}}>
                            {Intl.NumberFormat('en-US', {style: 'currency', currency: team.base_currency_symbol || 'USD'}).format(ticketGross)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className='form-row' style={{width: "265px"}}>
                  <div className='col-12 d-flex align-items-center justify-content-center'>
                    <img src="/uploading-loading.gif"
                          style={{width: "16px"}} />
                  </div>
                </div>
              )
            }>
      <div className='d-flex align-items-start justify-content-start w-100 h-100'
            style={{
              cursor: (info.event.extendedProps.authorized ? "pointer" : "default"),
              opacity: (shouldApplyReducedOpacity(info.event) ? "0.5" : "1"),
              backgroundColor: (info.event.extendedProps.classification === "confirm" ? `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.1)` : "transparent"),
              padding: "4px"
            }}>
        <div className="align-self-stretch"
              style={{
                width: "4px",
                minWidth: "4px",
                marginRight: "4px",
                borderRadius: "2px",
                background: hexColor
              }}>
        </div>
        <div className="flex-grow-1" style={{minWidth: '0'}}>
          {info.event.extendedProps.is_in_series ? (
            <div style={{marginBottom: "2px"}}>
              <SeriesPill size="sm" />
            </div>
          ) : null}
          <span className="fc-event-first-line mb-0 d-inline-block text-truncate"
              style={{maxWidth: "100%", marginTop: "-2px"}}
              title={marketingDates ? marketingDates.title : info.event.title}>
            {marketingDates ? marketingDates.title : info.event.title}
          </span>
          {marketingDates ? (
            <>
              {info.event.extendedProps.venue_name ? (
                <p className='fc-event-second-line mb-0 text-truncate'
                    title={info.event.extendedProps.venue_name}>
                  {info.event.extendedProps.venue_name}
                </p>
              ) : null}
              <MarketingDateRows marketingDates={marketingDates.marketingDates}
                                 eventIconPath={eventIconPath} />
            </>
          ) : (
            <p className='fc-event-second-line mb-0 text-truncate'
                title={info.event.extendedProps.venue_name || undefined}>
              {formatEventTimeLine(info.timeText, info.event.extendedProps.venue_name)}
            </p>
          )}
        </div>
        {marketingDates ? null : (
          <img src={eventIconPath(info.event.extendedProps, true)}
                style={{
                  width: "16px",
                  minWidth: "16px",
                  marginLeft: "3px",
                  marginTop: "4px"
                }} />
        )}
      </div>
    </Tippy>
  );
};

const shouldApplyReducedOpacity = (event) => {
  if (event.extendedProps.classification === "past") {
    return true;
  }

  if (event.extendedProps.classification === "canceled") {
    const eventDate = new Date(event.start);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    eventDate.setHours(0, 0, 0, 0);
    return eventDate < today;
  }

  return false;
};

const DayViewConfirmEvent = ({
  info,
  team,
  eventIconPath
}) => {
  const hexToRGB = (hex) => {
    hex = hex.replace(/^#/, '');
    let bigint = parseInt(hex, 16);
    let r, g, b;

    if (hex.length === 3) {
      r = (bigint >> 8 & 0xF) * 17;
      g = (bigint >> 4 & 0xF) * 17;
      b = (bigint & 0xF) * 17;
    } else {
      r = (bigint >> 16) & 255;
      g = (bigint >> 8) & 255;
      b = bigint & 255;
    }

    return { r, g, b };
  };

  const formatShowDetailTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    }).replace(/\s([AP]M)/, '$1');
  };

  const formatShowDetailDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const room = info.event.extendedProps.room;
  const hexColor = room.calendar_color_hex;
  const rgbColor = hexToRGB(hexColor);

  const marketingDates = marketingDateGroup(info);
  const spansMultipleEvents = !!info.event.extendedProps.spans_multiple_events;

  const holdPositionId = info.event.extendedProps.hold_position_id;
  const [showActivities, setShowActivities] = useState([]);
  const [totalTicketsSold, setTotalTicketsSold] = useState(null);
  const [ticketGross, setTicketGross] = useState(null);
  const [hasFetchedData, setHasFetchedData] = useState(false);

  const fetchTooltipData = () => {
    if (!holdPositionId || hasFetchedData) return;

    axios
      .get(`/teams/${team.id}/hold_positions/${holdPositionId}/tooltip`)
      .then(({data}) => {
        setHasFetchedData(true);
        setShowActivities(data.show_activities || []);
        setTotalTicketsSold(data.total_tickets_sold ?? null);
        setTicketGross(data.ticket_gross ?? null);
      })
      .catch(() => {
        setHasFetchedData(true);
        toastError("Failed to load event details");
      });
  };

  const isActivityCompleted = (activity) => {
    if (!activity || !activity.set || !activity.start_time) return false;
    const activityTime = new Date(activity.start_time);
    const now = new Date();
    return activityTime <= now;
  };

  const renderShowDetail = (activity, label, iconClassification, marginTop) => {
    const hasValue = activity && activity.set && activity.start_time;
    const valueText = hasValue
      ? `${formatShowDetailDate(activity.start_time)} - ${formatShowDetailTime(activity.start_time)}`
      : 'Not set';

    return (
      <div key={label} className='col-12 d-flex align-items-center' style={{ marginTop }}>
        <img
          src={eventIconPath({ classification: iconClassification }, false)}
          style={{ width: '14px', marginRight: '4px' }}
        />
        <p className='mb-0' style={{ fontSize: '11px', fontWeight: 600 }}>
          {label}
        </p>
        <p className='mb-0 flex-grow-1 text-right' style={{ fontSize: '11px' }}>
          {valueText}
        </p>
      </div>
    );
  };

  return (
    <Tippy
      className="calendar-view-tippy"
      distance={6}
      onShow={fetchTooltipData}
      content={
        hasFetchedData && showActivities.length > 0 ? (
          <div className='form-row' style={{ width: "265px" }}>
            <div className='col-12' style={{ fontSize: "10px", paddingLeft: 0, paddingRight: 0 }}>
              <div className='d-flex align-items-center'
                   style={{ marginBottom: "2px", justifyContent: "space-between" }}>
                {marketingDates ? (
                  <div>
                    <img src={eventIconPath({ classification: "announced" }, false)}
                         style={{ width: "14px", marginRight: "4px" }} />
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                      Series
                    </span>
                  </div>
                ) : info.event.extendedProps.classification === "canceled" ? (
                  <div>
                    <img src={eventIconPath({ classification: "canceled" }, false)}
                         style={{ width: "14px", marginRight: "4px" }} />
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                      Canceled
                    </span>
                  </div>
                ) : info.event.extendedProps.classification === "postponed" ? (
                  <div>
                    <img src={eventIconPath({ classification: "postponed" }, false)}
                         style={{ width: "14px", marginRight: "4px" }} />
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                      Postponed
                    </span>
                  </div>
                ) : (
                  <div>
                    <img src={eventIconPath({ classification: "confirm" }, false)}
                         style={{ width: "14px", marginRight: "4px" }} />
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                      Confirm
                    </span>
                  </div>
                )}
                <div>
                  {info.event.extendedProps.is_rental ? (
                    <div style={{ border: "1px solid var(--od-c-ffffff, #FFFFFF)", backgroundColor: "var(--od-c-ffffff, #FFFFFF)", borderRadius: "12px", padding: "2px 4px", color: "var(--od-c-333333, #333333)" }}>
                      Rental
                    </div>
                  ) : null}
                </div>
              </div>
              <p className='mb-0 text-truncate'
                 style={{ marginTop: "8px", fontSize: "14px", fontWeight: "bold", lineHeight: "20px" }}>
                <strong>{marketingDates ? marketingDates.title : info.event.title}</strong>
              </p>
              <p className='mb-0'
                 style={{ color: "var(--od-tooltip-text)", marginTop: "3px", fontSize: "12px", lineHeight: "18px" }}>
                {formatShowDetailDate(info.event.start)}
              </p>
              <p className='mb-0'
                 style={{ color: "var(--od-tooltip-text)", fontSize: "12px", lineHeight: "18px" }}>
                {room.name}
              </p>
            </div>
            <div className='col-12'
                 style={{ paddingTop: "10px", marginTop: "10px", borderTop: "1px solid var(--od-c-535862, #535862)", paddingLeft: 0, paddingRight: 0 }}>
              <div className='form-row'>
                {renderShowDetail(showActivities.find(sa => sa.name === "Announce"), "Announce", "announced", '3px')}
                {team.mode === "AGENT_MANAGER" && renderShowDetail(showActivities.find(sa => sa.name === "Artist Pre-Sale"), "Artist Pre-sale", "pre_sale", '7px')}
                {renderShowDetail(showActivities.find(sa => sa.name === "Venue Pre-Sale"), "Venue Pre-sale", "pre_sale", '7px')}
                {renderShowDetail(showActivities.find(sa => sa.name === "Public On-Sale"), "On sale", "on_sale", '7px')}
                {!spansMultipleEvents && totalTicketsSold != null && (
                  <div className='col-12 d-flex align-items-center' style={{ marginTop: '7px' }}>
                    <img src={eventIconPath({ classification: "on_sale" }, false)}
                         style={{ width: '14px', marginRight: '4px' }} />
                    <p className='mb-0' style={{ fontSize: '11px', fontWeight: 600 }}>
                      Tickets sold
                    </p>
                    <p className='mb-0 flex-grow-1 text-right' style={{ fontSize: '11px' }}>
                      {Intl.NumberFormat().format(totalTicketsSold)}
                    </p>
                  </div>
                )}
                {!spansMultipleEvents && ticketGross != null && (
                  <div className='col-12 d-flex align-items-center' style={{ marginTop: '7px' }}>
                    <img src={eventIconPath({ classification: "on_sale" }, false)}
                         style={{ width: '14px', marginRight: '4px' }} />
                    <p className='mb-0' style={{ fontSize: '11px', fontWeight: 600 }}>
                      Tickets gross
                    </p>
                    <p className='mb-0 flex-grow-1 text-right' style={{ fontSize: '11px' }}>
                      {Intl.NumberFormat('en-US', {style: 'currency', currency: team.base_currency_symbol || 'USD'}).format(ticketGross)}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className='form-row' style={{ width: "265px" }}>
            <div className='col-12 d-flex align-items-center justify-content-center'>
              <img src="/uploading-loading.gif" style={{ width: "16px" }} />
            </div>
          </div>
        )
      }
    >
      <div className='d-flex align-items-start justify-content-start w-100 h-100 day-view-confirm-event'
           style={{
             cursor: (info.event.extendedProps.authorized ? "pointer" : "default"),
             opacity: (shouldApplyReducedOpacity(info.event) ? "0.5" : "1"),
             backgroundColor: `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.1)`,
             padding: "4px",
             overflow: "hidden"
           }}>
        <div className="align-self-stretch"
             style={{
               width: "4px",
               minWidth: "4px",
               marginRight: "8px",
               borderRadius: "2px",
               background: hexColor
             }}>
        </div>
        <div className="flex-grow-1" style={{ minWidth: '0', overflow: 'hidden' }}>
          <div className="d-flex justify-content-between align-items-start">
            <div style={{ flex: 1, minWidth: 0 }}>
              {info.event.extendedProps.is_in_series ? (
                <div style={{marginBottom: "2px"}}>
                  <SeriesPill size="sm" />
                </div>
              ) : null}
              <p className="fc-event-first-line mb-0 text-truncate"
                 style={{ maxWidth: "100%", fontSize: "12px", fontWeight: "600" }}
                 title={marketingDates ? marketingDates.title : info.event.title}>
                {marketingDates ? marketingDates.title : info.event.title}
              </p>
              {marketingDates ? (
                <>
                  {info.event.extendedProps.venue_name ? (
                    <p className='fc-event-second-line mb-0 text-truncate'
                       style={{ fontSize: "10px", marginTop: "-2px" }}
                       title={info.event.extendedProps.venue_name}>
                      {info.event.extendedProps.venue_name}
                    </p>
                  ) : null}
                  <MarketingDateRows marketingDates={marketingDates.marketingDates}
                                     eventIconPath={eventIconPath} />
                </>
              ) : (
                <p className='fc-event-second-line mb-0 text-truncate'
                   style={{ fontSize: "10px", marginTop: "-2px" }}
                   title={info.event.extendedProps.venue_name || undefined}>
                  {formatEventTimeLine(info.timeText, info.event.extendedProps.venue_name)}
                </p>
              )}
            </div>
            {marketingDates ? null : (
              <div className="d-flex align-items-center" style={{ marginLeft: '8px' }}>
                <span style={{
                  fontSize: '10px',
                  color: 'var(--od-c-414651, #414651)',
                  marginRight: '4px'
                }}>
                  {getEventTypeLabel(info.event.extendedProps.classification)}
                </span>
                <img src={eventIconPath(info.event.extendedProps, true)}
                     style={{
                       width: "16px",
                       minWidth: "16px"
                     }} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Tippy>
  );
};

const MemoizedFullCalendar = React.memo(React.forwardRef(({showCalendarMenu, goToSpecificDate, ...calendarProps}, ref) => {
   return <FullCalendar ref={ref} {...calendarProps} />;
}), (prevProps, nextProps) => {
  return (
    prevProps.events === nextProps.events &&
    prevProps.initialDate === nextProps.initialDate &&
    prevProps.initialView === nextProps.initialView &&
    prevProps.firstDay === nextProps.firstDay &&
    prevProps.timeZone === nextProps.timeZone &&
    prevProps.showCalendarMenu === nextProps.showCalendarMenu &&
    prevProps.goToSpecificDate === nextProps.goToSpecificDate
  );
});

const CalendarViewV2 = ({
  browser,
  csrfToken,
  user,
  team,
  events,
  venuesOptions,
  venueSelected,
  venueOwnerships,
  updateSelectedVenue,
  submitNewEventForm,
  onInit,
  fetchTeamVenueConflicts,
  calendarEventConflicts,
  calendarEventConflictsModalOpen,
  closeCalendarEventConflictsModal,
  confirmTeamVenueConflicts,
  saveUserCalendarStartDay,
  calendarEventConflictMergeCheckboxClicked,
  holdGroup,
  confirm,
  confirmChanged,
  calendarEventTitle,
  updateCalendarEventTitle,
  calendarEventArtists,
  updateCalendarEventArtists,
  calendarEventType,
  updateCalendarEventType,
  calendarEventTicketForecast,
  calendarEventTicketForecastChanged,
  calendarEventNoteEditorState,
  updateCalendarEventNoteEditorState,
  calendarEventErrors,
  calendarEventFormClosed,
  userChangedCalendarEventTitle,
  onSaleEnabled,
  preSaleEnabled,
  artistPreSaleEnabled,
  announcedEnabled,
  confirmedEnabled,
  holdsEnabled,
  pastEventsEnabled,
  cancelledEventsEnabled,
  toggleOnSaleEnabled,
  togglePreSaleEnabled,
  toggleArtistPreSaleEnabled,
  toggleAnnouncedEnabled,
  toggleConfirmedEnabled,
  toggleHoldsEnabled,
  togglePastEventsEnabled,
  toggleCancelledEventsEnabled,
  holdGroupCalendarDateClicked,
  holdGroupDates,
  holdGroupHoldPositionUpdated,
  holdPositionTargetToggled,
  holdGroupHoldRemoved,
  confirmStartDateUpdated,
  confirmStartTimeUpdated,
  fetchHoldAvailability,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableFilters,
  reloadDataTable,
  dataTableEl,
  dataTableElChanged,
  selectedPromoter,
  selectedPromoterChanged,
  buyers,
  buyersChanged,
  promoters,
  promotersChanged,
  selectedBuyer,
  selectedBuyerChanged,
  holdGroupDeletion,
  holdGroupDeletionChanged,
  holdGroupDeletionReasonChanged,
  holdGroupDeletionExplanationChanged,
  holdGroupDeletionFollowUpChanged,
  holdGroupDeletionFollowUpAtChanged,
  deleteHoldGroup,
  searchTerm,
  searchTermChanged,
  currentTeamMembership,
  saveTeamMembershipCalendarState,
  submittingForm,
  doorsTimeDefault,
  eventEndTimeDefault,
  eventTimeDefaults,
  userChangedDoorsTime,
  userChangedDoorsTimeChanged,
  userChangedEventEndTime,
  userChangedEventEndTimeChanged,
  applyTimeDefaults,
  checkAvailsIsOpen,
  checkAvailsIsOpenChanged,
  checkAvailsSettings,
  checkAvailsSettingsChanged,
  calendarSyncIsOpen,
  calendarSyncIsOpenChanged,
  checkAvailsDates,
  checkAvailsDatesChanged,
  checkAvailsCalendarEvents,
  checkAvailsCalendarEventsChanged,
  fetchCheckAvailsCalendarEvents,
  checkAvailsLoading,
  checkAvailsLoadingChanged,
  holdGroupChanged,
  fetchCalendarEventsForSelectedVenues,
  dataTableFiltersChanged,
  currentTeamMembershipChanged,
  venueOwnershipsChanged,
  rooms,
  roomsChanged,
  reorderRooms,
  canCompTickets,
  conductorEnabled,
  canReadHoldChallenges,
  canManageHoldChallenges,
  reorderHoldPositions,
  clearHoldPosition,
  canManageVenues,
  venueStateOptions,
  availableTimezones
}) => {
  const canSelectMultipleVenues = team.package.name !== "Opener";
  const isMobile = browser.is.small || browser.is.extraSmall || isMobileOnly;

  const [selectedVenues, setSelectedVenues] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState(
    rooms.filter((r) =>
      currentTeamMembership.calendar_room_ids.includes(r.id)
    ).map((r) => {
      return { value: r.id, label: r.name };
    })
  );

  const [onlySelectedRoom, setOnlySelectedRoom] = useState(null);
  useEffect(() => {
    if(selectedRooms.length === 1){
      setOnlySelectedRoom(
        rooms.find((r) => r.id === selectedRooms[0].value)
      );
    } else {
      setOnlySelectedRoom(null);
    }
  }, [selectedRooms]);

  useEffect(() => {
    var selectedVenueOwnerships = venueOwnerships.filter((vo) =>
      selectedRooms.some((r) => vo.room_ids.includes(r.value))
    );

    var venueIds = selectedVenueOwnerships
      .filter((vo) => vo.venueable_type === "Venue")
      .map((vo) => vo.venueable_id);

    var updated = venuesOptions.filter((vo) =>
      venueIds.includes(vo.id)
    ).map((vo) => {
      return { value: vo.id, label: vo.name };
    })

    setSelectedVenues(updated);
  }, [selectedRooms, venuesOptions]);

  const [selectedTags, setSelectedTags] = useState(currentTeamMembership.calendar_tag_names || []);
  const [calendarEventSeries, setCalendarEventSeries] = useState([]);

  useEffect(() => {
    if(selectedRooms.length === 0){
      setCalendarEventSeries([]);
      return;
    }

    axios.get(`/teams/${team.id}/event_series/calendar_filter.json`, {
      params: { room_ids: selectedRooms.map((s) => s.value) }
    }).then(({ data }) => {
      setCalendarEventSeries(data.event_series || []);
    }).catch(() => {
      setCalendarEventSeries([]);
    });
  }, [team.id, selectedRooms]);
  const [recordCount, setRecordCount] = useState(0);
  const [goToSpecificDate, setGoToSpecificDate] = useState(null);
  const [showClearHoldsPopup, setShowClearHoldsPopup] = useState(false);
  const [reorderPopover, setReorderPopover] = useState({ open: false, holds: [] });
  const [challengeHoldToRelease, setChallengeHoldToRelease] = useState(null);
  const {
    holdBeingCleared,
    clearHoldOpen,
    handleClearHoldClick,
    closeClearHold
  } = useClearHold(events, user);
  const [showKeyboardShortcutsModal, setShowKeyboardShortcutsModal] = useState(false);
  const [showGoToDateModal, setShowGoToDateModal] = useState(false);
  const [mobileViewMode, setMobileViewMode] = useState(currentTeamMembership.calendar_view === 'list' ? 'list' : 'month');
  const [mobileTodaySignal, setMobileTodaySignal] = useState(0);
  const [mobileGoToDate, setMobileGoToDate] = useState(null);
  const [mobileRefreshSignal, setMobileRefreshSignal] = useState(0);
  const [mobileHighlightedHoldPositionIds, setMobileHighlightedHoldPositionIds] = useState([]);
  const debounceDatesSet = useRef(false);
  const holdsByDay = useMemo(() => groupActiveHoldsByDay(events), [events]);
  const holdsByDayRef = useRef(holdsByDay);
  holdsByDayRef.current = holdsByDay;
  const highlightedHoldPositionIds = useRef([]);
  const highlightTimer = useRef(null);
  const viewSwitchInProgress = useRef(false);

  // Some situations require us to have a default venue, such
  // as if the user clicks on the calendar to open the event form.
  useEffect(() => {
    if(selectedVenues.length === 1){
      updateSelectedVenue(venuesOptions, selectedVenues[0]);
    } else {
      updateSelectedVenue(venuesOptions, {value: venuesOptions[0].id});
    }
  }, [selectedVenues])

  useEffect(() => {
    if(venueSelected && venueSelected.id){
      setGonTimeZoneFromVenue(venueOwnerships, venueSelected.id);
    }
  }, [venueSelected])

  useEffect(() => {
    onInit(team, selectedRooms, selectedTags, user, dataTableFilters);
    const params = (new URL(document.location)).searchParams;
    const artist = params.get("artist");

    if (artist) {
      const decodedArtist = decodeURIComponent(window.location.search.split("=")[1])
      searchTermChanged(decodedArtist)
    }
  }, [])

  const checkAvailsRooms = useMemo(
    () => resolveCheckAvailsRooms(selectedRooms, rooms, checkAvailsSettings.roomId),
    [selectedRooms, rooms, checkAvailsSettings.roomId]
  );

  useEffect(() => {
    checkAvailsCalendarEventsChanged(null);

    if(checkAvailsDates.length !== 2){
      return undefined;
    }

    const controller = new AbortController();
    fetchCheckAvailsCalendarEvents(team, checkAvailsRooms, checkAvailsDates, controller.signal);

    return () => {
      controller.abort();
      checkAvailsLoadingChanged(false);
    };
  }, [
    checkAvailsDates,
    checkAvailsCalendarEventsChanged,
    fetchCheckAvailsCalendarEvents,
    checkAvailsLoadingChanged,
    checkAvailsRooms
  ])

  useEffect(() => {
    if(browser.lessThan.large){
      updateTeamMembershipSetting({ show_calendar_menu: false });
    }
  }, [browser.lessThan.large, updateTeamMembershipSetting])

  useEffect(() => {
    setRecordCount(0);

    if (Object.keys(dataTableEl).length > 0) {
      const table = $(dataTableEl).DataTable();
      table.on('draw.dt', function() {
        setRecordCount(table.page.info().recordsTotal);
      });
    }
  }, [dataTableEl, currentTeamMembership.calendar_view]);

  useEffect(() => {
    if (calendarRef.current && goToSpecificDate) {
      calendarRef.current.getApi().gotoDate(goToSpecificDate);
    }
  }, [goToSpecificDate]);

  const popupRef = useRef(null);
  const calendarRef = useRef(null);
  const calendarContainerRef = useRef(null);

  const handleReorderHoldPositions = useCallback((positionMapping) => {
    const scrollY = window.scrollY;
    const fcScroller = calendarContainerRef.current?.querySelector('.fc-scroller-liquid-absolute');
    const fcScrollTop = fcScroller ? fcScroller.scrollTop : 0;

    reorderHoldPositions(csrfToken, team, positionMapping, selectedRooms, selectedTags);

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
      if (fcScroller) fcScroller.scrollTop = fcScrollTop;
    });
  }, [csrfToken, team, selectedRooms, selectedTags, reorderHoldPositions]);

  const handleClearHold = useCallback(() => (
    clearHoldPosition(csrfToken, team, holdBeingCleared.hold_position_id, selectedRooms, selectedTags)
  ), [csrfToken, team, holdBeingCleared, selectedRooms, selectedTags, clearHoldPosition]);

  const openHoldsOnDate = useCallback((start, roomId) => {
    const holds = holdsOnDate(holdsByDayRef.current, { start, room_id: roomId });
    if (holds.length >= 2) {
      setReorderPopover({ open: true, holds, date: moment(start).format('YYYY-MM-DD') });
    }
  }, []);

  const startChallengeFromCalendar = useCallback((event) => {
    const { hold_position_id: holdPositionId, room_id: roomId } = event.extendedProps;

    startHoldChallenge(team, holdPositionId)
      .then((challenge) => {
        const holds = holdsOnDate(holdsByDayRef.current, { start: event.start, room_id: roomId })
          .map((hold) => (hold.hold_position_id === holdPositionId
            ? { ...hold, challenges: [...(hold.challenges || []), challengerSideOf(challenge)] }
            : hold));

        setReorderPopover({ open: true, holds, date: moment(event.start).format('YYYY-MM-DD'), startedChallenge: challenge });
        fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags);
      })
      .catch((error) => {
        toastError(holdChallengeErrorMessage(error, 'Could not start the challenge.'));
        fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags);
      });
  }, [team, selectedRooms, selectedTags, fetchCalendarEventsForSelectedVenues]);

  const applyChallengeHighlight = useCallback(() => {
    const container = calendarContainerRef.current;
    if (!container) return;

    container.querySelectorAll('.hold-challenge-highlight')
      .forEach((el) => el.classList.remove('hold-challenge-highlight'));
    highlightedHoldPositionIds.current.forEach((id) => {
      container.querySelectorAll(`[data-hold-position-id="${id}"]`)
        .forEach((el) => el.classList.add('hold-challenge-highlight'));
    });
  }, []);

  const refreshChallenges = useCallback(() => {
    if (isMobile) {
      setMobileRefreshSignal((signal) => signal + 1);
    } else {
      fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags);
    }
  }, [isMobile, team, selectedRooms, selectedTags, fetchCalendarEventsForSelectedVenues]);

  const goToChallenge = useCallback((challenge) => {
    clearTimeout(highlightTimer.current);
    const holdPositionIds = [challenge.challenger, challenge.challenged]
      .filter(Boolean)
      .map((hold) => hold.hold_position_id);

    if (isMobile) {
      setMobileViewMode('month');
      setMobileGoToDate({ date: moment.parseZone(challenge.date).format('YYYY-MM-DD') });
      setMobileHighlightedHoldPositionIds(holdPositionIds);
      highlightTimer.current = setTimeout(() => setMobileHighlightedHoldPositionIds([]), CHALLENGE_HIGHLIGHT_MS);
      return;
    }

    highlightedHoldPositionIds.current = holdPositionIds;
    calendarRef.current?.getApi().gotoDate(new Date(challenge.date));
    applyChallengeHighlight();

    highlightTimer.current = setTimeout(() => {
      highlightedHoldPositionIds.current = [];
      applyChallengeHighlight();
    }, CHALLENGE_HIGHLIGHT_MS);
  }, [applyChallengeHighlight, isMobile]);

  useEffect(() => () => clearTimeout(highlightTimer.current), []);

  useEffect(() => {
    if (mobileGoToDate) setMobileGoToDate(null);
  }, [mobileGoToDate]);

  const releaseChallengedHold = useCallback((challenge) => {
    setChallengeHoldToRelease({
      hold_position_id: challenge.challenged.hold_position_id,
      position: challenge.challenged.position,
      title: challenge.challenged.title,
      start: challenge.date,
      roomNames: challenge.room_names || []
    });
  }, []);

  const holdChallengesMenu = canReadHoldChallenges ? (
    <HoldChallengesMenu
      team={team}
      canManageHoldChallenges={canManageHoldChallenges}
      canClearHolds={Boolean(user.can_clear_holds)}
      refreshKey={isMobile ? mobileRefreshSignal : events}
      onGoToChallenge={goToChallenge}
      onReleaseHold={releaseChallengedHold}
      onChallengesChanged={refreshChallenges}
      compact={isMobile}
    />
  ) : null;

  const [dynamicEventMaxStack, setDynamicEventMaxStack] = useState(2);

  const calculateEventMaxStack = useCallback(() => {
    const calendarApi = calendarRef.current?.getApi();
    const currentView = calendarApi?.view?.type;

    if (currentView !== 'timeGridDay') {
      return 2;
    }

    if (!calendarContainerRef.current) return 2;

    const dayColumn = calendarContainerRef.current?.querySelector('.fc-timegrid-col:not(.fc-timegrid-axis)');
    if (!dayColumn) return 2;

    const columnWidth = dayColumn.offsetWidth;
    const availableWidth = columnWidth - COLUMN_PADDING;
    const eventsPerRow = Math.floor(availableWidth / (MIN_EVENT_WIDTH_DAY_VIEW + EVENT_GAP));

    return Math.max(eventsPerRow, 2);
  }, []);

  const updateEventMaxStack = useCallback(() => {
    const newMaxStack = calculateEventMaxStack();
    setDynamicEventMaxStack(prev => {
      if (newMaxStack !== prev) {
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi) {
          calendarApi.setOption('eventMaxStack', newMaxStack);
        }
        return newMaxStack;
      }
      return prev;
    });
  }, [calculateEventMaxStack]);

  useEffect(() => {
    if (!calendarContainerRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      setTimeout(updateEventMaxStack, RESIZE_DEBOUNCE_DELAY);
    });
    resizeObserver.observe(calendarContainerRef.current);

    setTimeout(updateEventMaxStack, INITIAL_CALCULATION_DELAY);

    return () => resizeObserver.disconnect();
  }, [updateEventMaxStack]);

  const hotkeyOptions = {
    enabled: !clearHoldOpen,
    enableOnContentEditable: false,
    enableOnFormTags: false,
    preventDefault: true
  };

  // Helper function to update team membership settings
  const updateTeamMembershipSetting = useCallback((updates) => {
    const updated = { ...currentTeamMembership, ...updates };
    currentTeamMembershipChanged(updated);
    return saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, updates);
  }, [currentTeamMembership, currentTeamMembershipChanged, csrfToken, team]);

  // C - Create new event (default = Hold)
  useHotkeys('c', () => {
    if (user.can_create_calendar_event || user.can_create_hold_group) {
      if (popupRef.current && popupRef.current.TriggerEl) {
        popupRef.current.TriggerEl.click();
      }
    }
  }, hotkeyOptions);

  useHotkeys('shift+c', () => {
    if (user.can_create_calendar_event || user.can_create_hold_group) {
      if (popupRef.current && popupRef.current.TriggerEl) {
        updateCalendarEventType('Confirm');
        setTimeout(() => {
          popupRef.current.TriggerEl.click();
        }, 0);
      }
    }
  }, hotkeyOptions);

  useHotkeys('h', () => {
    if (user.can_create_calendar_event || user.can_create_hold_group) {
      if (popupRef.current && popupRef.current.TriggerEl) {
        updateCalendarEventType('HoldGroup');
        setTimeout(() => {
          popupRef.current.TriggerEl.click();
        }, 0);
      }
    }
  }, hotkeyOptions);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const isFormElement = e.target.matches('input, textarea, [contenteditable]');
      if (isFormElement) return;
      if (clearHoldOpen) return;

      // "?" - Show keyboard shortcuts
      if ((e.key === '?' || (e.shiftKey && e.key === '/')) && !showKeyboardShortcutsModal) {
        e.preventDefault();
        setShowKeyboardShortcutsModal(true);
      }

      // "/" - Focus search input
      if (e.key === '/' && !e.shiftKey) {
        e.preventDefault();
        const search = document.getElementById('calendar-search');
        if (search) search.focus();
      }

      // "`" (Backtick) - Toggle left sidebar
      if (e.key === '`') {
        e.preventDefault();
        updateTeamMembershipSetting({
          show_calendar_menu: !currentTeamMembership.show_calendar_menu
        });
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showKeyboardShortcutsModal, currentTeamMembership, updateTeamMembershipSetting, clearHoldOpen]);

  useEffect(() => {
    const fullCalendarView = FULL_CALENDAR_VIEWS[currentTeamMembership.calendar_view];
    if (fullCalendarView) {
      calendarRef.current?.getApi().changeView(fullCalendarView);
    }
  }, [currentTeamMembership.calendar_view]);

  // G - Go to date
  useHotkeys('g', () => {
    setShowGoToDateModal(true);
  }, hotkeyOptions);

  // P - Previous Period
  useHotkeys('p', () => {
    if (calendarRef.current) {
      debounceDatesSet.current = true;
      calendarRef.current.getApi().prev();
    }
  }, hotkeyOptions);

  // N - Next Period
  useHotkeys('n', () => {
    if (calendarRef.current) {
      debounceDatesSet.current = true;
      calendarRef.current.getApi().next();
    }
  }, hotkeyOptions);

  // T - Jump to today
  useHotkeys('t', () => {
    if (calendarRef.current) {
      calendarRef.current.getApi().today();
    }
  }, hotkeyOptions);

  // 1 or D - Day View
  useHotkeys('1, d', () => {
    if (viewSwitchInProgress.current) return;
    if (currentTeamMembership.calendar_view !== "calendar_daily") {
      viewSwitchInProgress.current = true;
      updateTeamMembershipSetting({ calendar_view: "calendar_daily" }).finally(() => {
        viewSwitchInProgress.current = false;
      });
    }
  }, hotkeyOptions, [currentTeamMembership, updateTeamMembershipSetting]);

  // 2 or W - Week View
  useHotkeys('2, w', () => {
    if (viewSwitchInProgress.current) return;
    if (currentTeamMembership.calendar_view !== "calendar_weekly") {
      viewSwitchInProgress.current = true;
      updateTeamMembershipSetting({ calendar_view: "calendar_weekly" }).finally(() => {
        viewSwitchInProgress.current = false;
      });
    }
  }, hotkeyOptions, [currentTeamMembership, updateTeamMembershipSetting]);

  // 3 or M - Month View
  useHotkeys('3, m', () => {
    if (viewSwitchInProgress.current) return;
    if (currentTeamMembership.calendar_view !== "calendar") {
      viewSwitchInProgress.current = true;
      updateTeamMembershipSetting({ calendar_view: "calendar" }).finally(() => {
        viewSwitchInProgress.current = false;
      });
    }
  }, hotkeyOptions, [currentTeamMembership, updateTeamMembershipSetting]);

  // 4 or L - List View
  useHotkeys('4, l', () => {
    if (viewSwitchInProgress.current) return;
    if (currentTeamMembership.calendar_view !== "list") {
      viewSwitchInProgress.current = true;
      updateTeamMembershipSetting({ calendar_view: "list" }).finally(() => {
        viewSwitchInProgress.current = false;
      });
    }
  }, hotkeyOptions, [currentTeamMembership, updateTeamMembershipSetting]);

  // A - Check avails
  useHotkeys('a', () => {
    checkAvailsIsOpenChanged(true);
  }, hotkeyOptions);

  // Shift+D - Clear holds on a date
  useHotkeys('shift+d', () => {
    setShowClearHoldsPopup(true);
  }, hotkeyOptions);

  // Escape - Close modals
  useHotkeys('escape', () => {
    if (showKeyboardShortcutsModal) {
      setShowKeyboardShortcutsModal(false);
    }
    if (showGoToDateModal) {
      setShowGoToDateModal(false);
    }
  }, { ...hotkeyOptions, enableOnFormTags: true });

  const eventIconPath = (event, dark) => {
    var path = "";

    switch (event.classification) {
      case "hold":
        path = (dark ? "icons/hold.svg" : "icons/hold-white.svg");
        break;
      case "confirm":
        path = (dark ? "icons/calendar-check.svg" : "icons/calendar-check-white.svg");
        break;
      case "announced":
        path = (dark ? "icons/announcement.svg" : "icons/announcement-white.svg");
        break;
      case "on_sale":
        path = (dark ? "icons/ticket.svg" : "icons/ticket-white.svg");
        break;
      case "canceled":
        path = (dark ? "icons/x-square.svg" : "icons/x-square-white.svg");
        break;
      case "postponed":
        path = (dark ? "icons/postponed.svg" : "icons/postponed-white.svg");
        break;
      case "past":
        path = (dark ? "icons/past.svg" : "icons/past-white.svg");
        break;
      case "pre_sale":
        path = (dark ? "icons/pre-sale.svg" : "icons/pre-sale-white.svg");
        break;
      case "artist_pre_sale":
        path = (dark ? "icons/pre-sale.svg" : "icons/pre-sale-white.svg");
        break;
    }

    return path;
  }

  const scrollCalendarToDate = (date) => {
    if(currentTeamMembership.calendar_view !== "calendar"){
      return false;
    }

    if(date){
      let scroller = calendarContainerRef.current.querySelector('.fc-scroller-liquid-absolute');
      let calendarDayEls = Array.from(calendarContainerRef.current.querySelectorAll('.fc-daygrid-day'));
      let targetDate = date.toISOString().slice(0, 10);

      let foundDayEl = calendarDayEls.find((dayEl) => {
        return dayEl.getAttribute('data-date') === targetDate;
      });

      if (foundDayEl && scroller) {
        const scrollerRect = scroller.getBoundingClientRect();
        const dayRect = foundDayEl.getBoundingClientRect();

        const isInView = (
          dayRect.top >= scrollerRect.top &&
            dayRect.bottom <= scrollerRect.bottom
        );

        if (!isInView) {
          const targetOffset = dayRect.top - scrollerRect.top;
          const scrollTop = scroller.scrollTop + targetOffset;

          scroller.scrollTo({
            top: scrollTop,
            behavior: 'instant'
          });
        }

        foundDayEl.classList.add("highlight");
        setTimeout(() => {
          foundDayEl.classList.remove("highlight");
        }, 2000);
      }
    }
  }

  const setTeamMembershipCurrentDate = (date) => {
    currentTeamMembershipChanged({
      ...currentTeamMembership,
      calendar_starts_at: date
    });

    saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
      calendar_starts_at: date
    });
  }

  const datesSet = (info) => {
    var date = (goToSpecificDate || info.view.currentStart);
    var adjustedDate = moment(date).startOf('day').add(12, 'hours').toDate();

    setTeamMembershipCurrentDate(adjustedDate);

    fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags, (data) => {
      if(goToSpecificDate){
        setTimeout(() => {
          scrollCalendarToDate(goToSpecificDate);
        }, 0);
      }
    });

    requestAnimationFrame(() => {
      if (calendarRef.current) {
        updateEventMaxStack();
      }
    });

    setGoToSpecificDate(null);
    debounceDatesSet.current = false;
  }

  const debouncedDatesSet = _.debounce((info) => {
    datesSet(info);
  }, 300);

  const getFilteredEvents = useCallback((info, successCallback, failureCallback) => {
    let filteredEvents = [...events];

    if(!onSaleEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "on_sale");
    }
    if(!preSaleEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "pre_sale");
    }
    if(!artistPreSaleEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "artist_pre_sale");
    }
    if(!announcedEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "announced");
    }
    if(!confirmedEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "confirm");
    }
    if(!holdsEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "hold");
    }
    if(!pastEventsEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "past");
    }
    if(!cancelledEventsEnabled) {
      filteredEvents = filteredEvents.filter((event) => event.classification !== "canceled");
    }

    const showVenueName = team.calendar_venue_name_enabled;

    filteredEvents = filteredEvents.map((event) => {
      const room = rooms.find((r) => r.id === event.room_id);
      const venueOwnership = showVenueName ? venueOwnerships.find((vo) => vo.id === room?.venue_ownership_id) : null;

      return {
        ...event,
        room: room,
        venue_name: venueOwnership?.name,
        venue_order: room?.position ?? ROOMLESS_VENUE_ORDER
      }
    });

    filteredEvents = groupSameSeriesSameDayMarketingDates(filteredEvents);

    successCallback(filteredEvents);
  }, [
    events,
    rooms,
    venueOwnerships,
    team.calendar_venue_name_enabled,
    onSaleEnabled,
    preSaleEnabled,
    artistPreSaleEnabled,
    announcedEnabled,
    confirmedEnabled,
    holdsEnabled,
    pastEventsEnabled,
    cancelledEventsEnabled
  ]);

  return (
    <div className="CalendarViewV2App">
      <ToastContainer icon={false} />
      <AnnouncementAlert csrfToken={csrfToken}
                          user={user}
                          team={team} />
      <ClearHoldsPopup
        csrfToken={csrfToken}
        user={user}
        team={team}
        showClearHoldsPopup={showClearHoldsPopup}
        setShowClearHoldsPopup={setShowClearHoldsPopup}
        selectedRooms={selectedRooms}
        selectedTags={selectedTags}
        fetchCalendarEventsForSelectedVenues={fetchCalendarEventsForSelectedVenues}
        currentCalendarDate={calendarRef.current?.getApi()?.getDate() || new Date()}
      />
      <HoldReorderPopover
        isOpen={reorderPopover.open}
        onClose={() => setReorderPopover({ open: false, holds: [], date: null })}
        startedChallenge={reorderPopover.startedChallenge}
        holds={reorderPopover.holds}
        date={reorderPopover.date}
        rooms={rooms}
        defaultTopHold={team.default_top_hold}
        onReorder={handleReorderHoldPositions}
        team={team}
        canManageHoldChallenges={canManageHoldChallenges}
        onChallengesChanged={() => fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags)}
      />
      {challengeHoldToRelease && (
        <ClearHoldModal
          hold={challengeHoldToRelease}
          roomNames={challengeHoldToRelease.roomNames}
          team={team}
          onClose={() => setChallengeHoldToRelease(null)}
          onConfirm={() => clearHoldPosition(csrfToken, team, challengeHoldToRelease.hold_position_id, selectedRooms, selectedTags)
            .then((cleared) => {
              if (cleared) setMobileRefreshSignal((signal) => signal + 1);
              return cleared;
            })}
        />
      )}
      {holdBeingCleared && (
        <ClearHoldModal
          hold={holdBeingCleared}
          roomNames={holdRoomNames(events, rooms, holdBeingCleared)}
          hexColor={rooms.find((room) => room.id === holdBeingCleared.room_id)?.calendar_color_hex}
          team={team}
          onClose={closeClearHold}
          onConfirm={handleClearHold}
        />
      )}
      {/* Mobile filter dropdown - renders from top on mobile */}
      {isMobile && currentTeamMembership.show_calendar_menu && (
        <div className="mobile-filter-overlay"
             onClick={() => updateTeamMembershipSetting({ show_calendar_menu: false })}>
          <div className="mobile-filter-dropdown"
               onClick={(e) => e.stopPropagation()}>
            <div className="mobile-filter-header">
              <span className="mobile-filter-title">Filters</span>
              <button
                className="mobile-filter-close"
                onClick={() => updateTeamMembershipSetting({ show_calendar_menu: false })}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="mobile-filter-content">
              <CalendarMenu team={team}
                            user={user}
                            csrfToken={csrfToken}
                            calendarRef={calendarRef.current || {}}
                            saveTeamMembershipCalendarState={saveTeamMembershipCalendarState}
                            currentTeamMembershipChanged={currentTeamMembershipChanged}
                            venuesOptions={venuesOptions}
                            setSelectedVenues={setSelectedVenues}
                            selectedRooms={selectedRooms}
                            setSelectedRooms={setSelectedRooms}
                            fetchCalendarEventsForSelectedVenues={fetchCalendarEventsForSelectedVenues}
                            selectedTags={selectedTags}
                            setSelectedTags={setSelectedTags}
                            fetchTeamVenueConflicts={fetchTeamVenueConflicts}
                            dataTableFilters={dataTableFilters}
                            dataTableFiltersChanged={dataTableFiltersChanged}
                            venueOwnerships={venueOwnerships}
                            canSelectMultipleVenues={canSelectMultipleVenues}
                            venueOwnershipsChanged={venueOwnershipsChanged}
                            onSaleEnabled={onSaleEnabled}
                            announcedEnabled={announcedEnabled}
                            confirmedEnabled={confirmedEnabled}
                            holdsEnabled={holdsEnabled}
                            pastEventsEnabled={pastEventsEnabled}
                            cancelledEventsEnabled={cancelledEventsEnabled}
                            preSaleEnabled={preSaleEnabled}
                            artistPreSaleEnabled={artistPreSaleEnabled}
                            toggleOnSaleEnabled={toggleOnSaleEnabled}
                            toggleAnnouncedEnabled={toggleAnnouncedEnabled}
                            toggleConfirmedEnabled={toggleConfirmedEnabled}
                            toggleHoldsEnabled={toggleHoldsEnabled}
                            togglePastEventsEnabled={togglePastEventsEnabled}
                            toggleCancelledEventsEnabled={toggleCancelledEventsEnabled}
                            toggleArtistPreSaleEnabled={toggleArtistPreSaleEnabled}
                            togglePreSaleEnabled={togglePreSaleEnabled}
                            searchTermChanged={searchTermChanged}
                            dataTableEl={dataTableEl}
                            browser={browser}
                            datesAreOnSameDay={datesAreOnSameDay}
                            setGoToSpecificDate={setGoToSpecificDate}
                            scrollCalendarToDate={scrollCalendarToDate}
                            setTeamMembershipCurrentDate={setTeamMembershipCurrentDate}
                            calendarContainerRef={calendarContainerRef}
                            rooms={rooms}
                            roomsChanged={roomsChanged}
                            reorderRooms={reorderRooms}
                            calendarEventSeries={calendarEventSeries}
                            currentTeamMembership={currentTeamMembership}
                            isMobileDropdown={true} />
            </div>
          </div>
        </div>
      )}
      <div className="form-row flex-nowrap">
        {/* Desktop side panel - only show on non-mobile */}
        {!isMobile && currentTeamMembership.show_calendar_menu ? (
          <div className='col-auto'>
            <CalendarMenu team={team}
                          user={user}
                          csrfToken={csrfToken}
                          saveTeamMembershipCalendarState={saveTeamMembershipCalendarState}
                          currentTeamMembershipChanged={currentTeamMembershipChanged}
                          venuesOptions={venuesOptions}
                          setSelectedVenues={setSelectedVenues}
                          selectedRooms={selectedRooms}
                          setSelectedRooms={setSelectedRooms}
                          fetchCalendarEventsForSelectedVenues={fetchCalendarEventsForSelectedVenues}
                          selectedTags={selectedTags}
                          setSelectedTags={setSelectedTags}
                          fetchTeamVenueConflicts={fetchTeamVenueConflicts}
                          dataTableFilters={dataTableFilters}
                          dataTableFiltersChanged={dataTableFiltersChanged}
                          venueOwnerships={venueOwnerships}
                          canSelectMultipleVenues={canSelectMultipleVenues}
                          venueOwnershipsChanged={venueOwnershipsChanged}
                          onSaleEnabled={onSaleEnabled}
                          announcedEnabled={announcedEnabled}
                          confirmedEnabled={confirmedEnabled}
                          holdsEnabled={holdsEnabled}
                          pastEventsEnabled={pastEventsEnabled}
                          cancelledEventsEnabled={cancelledEventsEnabled}
                          preSaleEnabled={preSaleEnabled}
                          artistPreSaleEnabled={artistPreSaleEnabled}
                          toggleOnSaleEnabled={toggleOnSaleEnabled}
                          toggleAnnouncedEnabled={toggleAnnouncedEnabled}
                          toggleConfirmedEnabled={toggleConfirmedEnabled}
                          toggleHoldsEnabled={toggleHoldsEnabled}
                          togglePastEventsEnabled={togglePastEventsEnabled}
                          toggleCancelledEventsEnabled={toggleCancelledEventsEnabled}
                          toggleArtistPreSaleEnabled={toggleArtistPreSaleEnabled}
                          togglePreSaleEnabled={togglePreSaleEnabled}
                          searchTermChanged={searchTermChanged}
                          dataTableEl={dataTableEl}
                          browser={browser}
                          datesAreOnSameDay={datesAreOnSameDay}
                          setGoToSpecificDate={setGoToSpecificDate}
                          scrollCalendarToDate={scrollCalendarToDate}
                          setTeamMembershipCurrentDate={setTeamMembershipCurrentDate}
                          calendarContainerRef={calendarContainerRef}
                          rooms={rooms}
                          roomsChanged={roomsChanged}
                          reorderRooms={reorderRooms}
                          calendarEventSeries={calendarEventSeries}
                          currentTeamMembership={currentTeamMembership} />
          </div>
        ) : null}
        <div className='col'>
          <div>
            {/* Mobile-only search bar - full width on small screens */}
            {isMobile && user.role.name !== "Promoter" && (
              <div className="d-flex align-items-center calendar-header-row" style={{ margin: "8px 0px 0px 0px" }}>
                <div className="flex-fill" style={{ minWidth: 0 }}>
                  <CalendarSearchInput value={searchTerm} onChange={searchTermChanged} shortcutHint={false} />
                </div>
                {holdChallengesMenu}
              </div>
            )}
            <div className={`d-flex calendar-header-row ${isMobile ? 'flex-nowrap' : 'flex-wrap'}`} style={{"margin": "8px 0px 0px 0px"}}>
              <div className={`pl-0 d-flex align-items-center justify-content-start calendar-header-row ${isMobile ? '' : 'flex-fill'}`}
                    style={{"marginBottom": "8px", "minWidth": 0}}>
                <Button
                  variant="secondary"
                  size="sm"
                  icon={Sliders01}
                  aria-label="Toggle filters"
                  onClick={() => {
                    updateTeamMembershipSetting({
                      show_calendar_menu: !currentTeamMembership.show_calendar_menu
                    });
                  }}
                />
                {calendarRef.current ? (
                  <>
                    <Button variant="secondary" size="sm" onClick={() => calendarRef.current.getApi().today()}>
                      Today
                    </Button>
                    <Button
                      variant="secondary"
                      size="sm"
                      icon={ChevronLeft}
                      aria-label="Previous"
                      onClick={() => {
                        debounceDatesSet.current = true;
                        calendarRef.current.getApi().prev();
                      }}
                    />
                    <Button
                      variant="secondary"
                      size="sm"
                      icon={ChevronRight}
                      aria-label="Next"
                      onClick={() => {
                        debounceDatesSet.current = true;
                        calendarRef.current.getApi().next();
                      }}
                    />
                    <h2 className="calendar-header-title">
                      {calendarRef.current.getApi().getCurrentData().viewTitle}
                    </h2>
                  </>
                ) : (
                  !isMobile && (
                    <>
                      <p className='mb-0'
                          style={{
                            "fontSize": "18px",
                            "fontWeight": "600",
                            "marginRight": "8px"
                          }}>
                        My events
                      </p>
                      {Object.keys(dataTableEl).length > 0 ? (
                        <div style={{
                          "background": "var(--sl-bg-brand-primary)",
                          "border": "1px solid var(--sl-border-brand)",
                          "borderRadius": "9px",
                          "padding": "2px 8px",
                          "color": "var(--sl-text-brand)"
                        }}>
                          <p className='mb-0 small'>
                            {recordCount.toLocaleString()}
                          </p>
                        </div>
                      ) : null}
                    </>
                  )
                )}
              </div>
              <div className="flex-fill pr-0 d-flex align-items-center justify-content-end calendar-header-row"
                    style={{"marginBottom": "8px"}}>
                {/* Desktop/tablet search bar - hidden on mobile */}
                {!isMobile && user.role.name !== "Promoter" ? (
                  <CalendarSearchInput value={searchTerm} onChange={searchTermChanged} />
                ) : null}
                {isMobile && (
                  <Button
                    variant="secondary"
                    size="sm"
                    icon={mobileViewMode === 'list' ? CalendarDate : ListIcon}
                    aria-label={mobileViewMode === 'list' ? 'Show month view' : 'Show list view'}
                    onClick={() => setMobileViewMode(mobileViewMode === 'list' ? 'month' : 'list')}
                  />
                )}
                {isMobile && (
                  <Button variant="secondary" size="sm" onClick={() => setMobileTodaySignal((s) => s + 1)}>
                    Today
                  </Button>
                )}
                {!isMobile && calendarRef.current ? holdChallengesMenu : null}
                <CalendarOptions csrfToken={csrfToken}
                            user={user}
                            team={team}
                            saveUserCalendarStartDay={saveUserCalendarStartDay}
                            currentTeamMembership={currentTeamMembership}
                            checkAvailsIsOpenChanged={checkAvailsIsOpenChanged}
                            calendarSyncIsOpenChanged={calendarSyncIsOpenChanged}
                            fetchCalendarEventsForSelectedVenues={fetchCalendarEventsForSelectedVenues}
                            selectedRooms={selectedRooms}
                            selectedTags={selectedTags}
                            showExportCsv={currentTeamMembership.calendar_view === "list"}
                            dataTableEl={dataTableEl}
                            dataTableFilters={dataTableFilters}
                            setShowClearHoldsPopup={setShowClearHoldsPopup}
                            updateTeamMembershipSetting={updateTeamMembershipSetting}>
                  <span className="calendar-popup-trigger">
                    <Button variant="secondary" size="sm" trailingIcon={isMobile ? undefined : ChevronDown}>
                      Options
                    </Button>
                  </span>
                </CalendarOptions>
                {!isMobile && (
                  <Tooltip title="Keyboard shortcuts (?)">
                    <Button
                      variant="secondary"
                      size="sm"
                      icon={Keyboard01}
                      aria-label="Keyboard shortcuts"
                      onClick={() => setShowKeyboardShortcutsModal(true)}
                    />
                  </Tooltip>
                )}
                {user.can_create_calendar_event || user.can_create_hold_group ? (
                  <Popup arrow={false}
                        ref={popupRef}
                        className="new-event-popup"
                        offsetY={5}
                        offsetX={(isMobile ? 15 : 0)}
                        position="bottom right"
                        contentStyle={newContentStyle}
                        overlayStyle={{ zIndex: "199" }}
                        closeOnDocumentClick={false}
                          onOpen={(e) => {
                            e.preventDefault();
                            // Setup dragging when popup opens
                            setTimeout(() => {
                              const dragHandle = document.querySelector('.drag-handle');
                              const popupContainer = document.querySelector('.new-event-popup-content');
                              
                              if (!dragHandle || !popupContainer) return;

                              let isDragging = false;
                              let dragOffset = { x: 0, y: 0 };

                              const handleMouseDown = (e) => {
                                isDragging = true;
                                const rect = popupContainer.getBoundingClientRect();
                                dragOffset.x = e.clientX - rect.left;
                                dragOffset.y = e.clientY - rect.top;
                                
                                document.addEventListener('mousemove', handleMouseMove);
                                document.addEventListener('mouseup', handleMouseUp);
                                e.preventDefault();
                              };

                              const handleMouseMove = (e) => {
                                if (!isDragging) return;
                                
                                const newX = e.clientX - dragOffset.x;
                                const newY = e.clientY - dragOffset.y;
                                
                                // Apply basic bounds to keep popup visible
                                const bodyRect = document.body.getBoundingClientRect();
                                const popupRect = popupContainer.getBoundingClientRect();
                                
                                const minX = -popupRect.width + 100;
                                const maxX = bodyRect.width - 100;
                                const minY = 0;
                                const maxY = bodyRect.height - 100;
                                
                                const boundedX = Math.max(minX, Math.min(maxX, newX));
                                const boundedY = Math.max(minY, Math.min(maxY, newY));
                                
                                popupContainer.style.left = `${boundedX}px`;
                                popupContainer.style.top = `${boundedY}px`;
                                popupContainer.style.position = 'fixed';
                              };

                              const handleMouseUp = () => {
                                isDragging = false;
                                document.removeEventListener('mousemove', handleMouseMove);
                                document.removeEventListener('mouseup', handleMouseUp);
                              };

                              // Only add event listener if not already added
                              if (!dragHandle.dataset.dragSetup) {
                                dragHandle.dataset.dragSetup = 'true';
                                dragHandle.addEventListener('mousedown', handleMouseDown);
                              }
                            }, 50);
                          }}
                          onClose={
                            () => {
                              calendarEventFormClosed(() => {
                                reloadDataTable();
                              });
                            }
                          }
                          trigger={open => (
                      <span className="calendar-popup-trigger">
                        <Button variant="primary" size="sm" icon={isMobile ? undefined : Plus}>
                          New Event
                        </Button>
                      </span>
                                        )} >
                        {close => (
                          <div className='text-left'>
                            <EventForm formTitle={"New Event"}
                                  formButtonLabel={"Create Event"}
                                  csrfToken={csrfToken}
                                  currentUser={user}
                                  team={team}
                                  venuesOptions={venuesOptions}
                                  venueSelected={venueSelected}
                                  rooms={rooms}
                                  preSelectedRooms={
                                    onlySelectedRoom ? [onlySelectedRoom] : []
                                  }
                                  venueOwnerships={venueOwnerships}
                                  submitEventForm={submitNewEventForm}
                                  onSuccess={(url) => {window.location.href = url;}}
                                  updateSelectedVenue={updateSelectedVenue}
                                  onVenueChange={
                                    (selected) => {
                                      if (selected) {
                                        saveTeamMembershipCalendarState(csrfToken, team, currentTeamMembership, {
                                          calendar_venue_id: selected.value
                                        });
                                      }
                                    }
                                  }
                                  onClose={
                                    () => {
                                      close();
                                    }
                                  }
                                  holdGroup={holdGroup}
                                  confirm={confirm}
                                  confirmChanged={confirmChanged}
                                  calendarEventFormClosed={calendarEventFormClosed}
                                  calendarEventTitle={calendarEventTitle}
                                  updateCalendarEventTitle={updateCalendarEventTitle}
                                  calendarEventArtists={calendarEventArtists}
                                  updateCalendarEventArtists={updateCalendarEventArtists}
                                  calendarEventType={calendarEventType}
                                  updateCalendarEventType={updateCalendarEventType}
                                  calendarEventTicketForecast={calendarEventTicketForecast}
                                  calendarEventTicketForecastChanged={calendarEventTicketForecastChanged}
                                  calendarEventNoteEditorState={calendarEventNoteEditorState}
                                  updateCalendarEventNoteEditorState={updateCalendarEventNoteEditorState}
                                  userChangedCalendarEventTitle={userChangedCalendarEventTitle}
                                  holdGroupCalendarDateClicked={holdGroupCalendarDateClicked}
                                  holdGroupDates={holdGroupDates}
                                  holdGroupHoldPositionUpdated={holdGroupHoldPositionUpdated}
                                  holdPositionTargetToggled={holdPositionTargetToggled}
                                  holdGroupHoldRemoved={holdGroupHoldRemoved}
                                  confirmStartDateUpdated={confirmStartDateUpdated}
                                  confirmStartTimeUpdated={confirmStartTimeUpdated}
                                  fetchHoldAvailability={fetchHoldAvailability}
                                  calendarRef={calendarRef.current || {}}
                                  calendarStartDate={new Date(currentTeamMembership.calendar_starts_at)}
                                  selectedPromoter={selectedPromoter}
                                  selectedPromoterChanged={selectedPromoterChanged}
                                  buyers={buyers}
                                  buyersChanged={buyersChanged}
                                  promoters={promoters}
                                  promotersChanged={promotersChanged}
                                  selectedBuyer={selectedBuyer}
                                  selectedBuyerChanged={selectedBuyerChanged}
                                  holdGroupDeletion={holdGroupDeletion}
                                  holdGroupDeletionChanged={holdGroupDeletionChanged}
                                  holdGroupDeletionReasonChanged={holdGroupDeletionReasonChanged}
                                  holdGroupDeletionExplanationChanged={holdGroupDeletionExplanationChanged}
                                  holdGroupDeletionFollowUpChanged={holdGroupDeletionFollowUpChanged}
                                  holdGroupDeletionFollowUpAtChanged={holdGroupDeletionFollowUpAtChanged}
                                  deleteHoldGroup={deleteHoldGroup}
                                  submittingForm={submittingForm}
                                  calendarEventErrors={calendarEventErrors}
                                  doorsTimeDefault={doorsTimeDefault}
                                  eventEndTimeDefault={eventEndTimeDefault}
                                  eventTimeDefaults={eventTimeDefaults}
                                  userChangedDoorsTime={userChangedDoorsTime}
                                  userChangedDoorsTimeChanged={userChangedDoorsTimeChanged}
                                  userChangedEventEndTime={userChangedEventEndTime}
                                  userChangedEventEndTimeChanged={userChangedEventEndTimeChanged}
                                  holdGroupChanged={holdGroupChanged}
                                  applyTimeDefaults={applyTimeDefaults}
                                  canManageVenues={canManageVenues}
                                  venueStateOptions={venueStateOptions}
                                  availableTimezones={availableTimezones}
                                  roomsChanged={roomsChanged}
                                  venueOwnershipsChanged={venueOwnershipsChanged}
                                  draggableHeader
                                  />
                          </div>
                        )}
                      </Popup>
                    ) : null}
              </div>
            </div>
            {!isMobile && (currentTeamMembership.calendar_view === "calendar" || currentTeamMembership.calendar_view === "calendar_weekly" || currentTeamMembership.calendar_view === "calendar_daily") ? (
              <div ref={calendarContainerRef}>
                <MemoizedFullCalendar buttonText={{today: "Today"}}
                              ref={calendarRef}
                              showCalendarMenu={currentTeamMembership.show_calendar_menu}
                              goToSpecificDate={goToSpecificDate}
                              dateClick={
                                (info) => {
                                  if(popupRef.current.state.isOpen){
                                    return false;
                                  };

                                  popupRef.current.TriggerEl.click();

                                  var date = info.date;
                                  date.setHours(12, 0, 0, 0);

                                  // Same as onDayClick in EventForm
                                  holdGroupCalendarDateClicked(date, undefined);
                                  fetchHoldAvailability(team, (onlySelectedRoom ? [onlySelectedRoom.id] : []), date);
                                }
                              }
                              initialDate={currentTeamMembership.calendar_starts_at}
                              datesSet={
                                (info) => {
                                  if(debounceDatesSet.current){
                                    debouncedDatesSet(info);
                                  } else {
                                    datesSet(info);
                                  }
                                }
                              }
                              firstDay={user.calendar_start_day}
                              headerToolbar={{
                                start: '',
                                center: '',
                                end:  ''
                              }}
                              defaultTimedEventDuration={'00:00:01'}
                              nextDayThreshold={NEXT_DAY_THRESHOLD}
                              events={getFilteredEvents}
                              eventClick={
                                (eventInfo) => {
                                  if (handleClearHoldClick(eventInfo)) return false;

                                  if (eventInfo.jsEvent.target.closest(`[${START_CHALLENGE_ATTRIBUTE}]`)) {
                                    eventInfo.jsEvent.preventDefault();
                                    startChallengeFromCalendar(eventInfo.event);
                                    return false;
                                  }

                                  if (eventInfo.jsEvent.target.closest(`[${HOLDS_ON_DATE_ATTRIBUTE}]`)) {
                                    eventInfo.jsEvent.preventDefault();
                                    openHoldsOnDate(eventInfo.event.start, eventInfo.event.extendedProps.room_id);
                                    return false;
                                  }

                                  if(!eventInfo.event.extendedProps.authorized){
                                    eventInfo.jsEvent.preventDefault();
                                    return false;
                                  }
                                }
                              }
                              eventOrder={
                                team.calendar_hold_grouping === "by_venue"
                                  ? ["type_position", "venue_order", "position", "start"]
                                  : ["type_position", "position", "venue_order", "start"]
                              }
                              eventTimeFormat={{
                                hour: 'numeric',
                                minute: '2-digit',
                                meridiem: 'short'
                              }}
                              eventClassNames={
                                (info) => {
                                  var extraClasses = [];
                                  extraClasses.push("fc-event-" + info.event.extendedProps.type);

                                  if (info.event.extendedProps.is_rental) {
                                    extraClasses.push("fc-event-rental");
                                  }

                                  if (highlightedHoldPositionIds.current.includes(info.event.extendedProps.hold_position_id)) {
                                    extraClasses.push("hold-challenge-highlight");
                                  }

                                  return extraClasses.join(" ");
                                }
                              }
                              eventContent= {
                                (info) => {
                                  const isDayView = info.view.type === 'timeGridDay';

                                  if (info.event.extendedProps.type === "Hold") {
                                    const hold = { ...info.event.extendedProps, start: info.event.start };
                                    const isActiveAuthorizedHold = hold.authorized && !hold.cleared_at && !hold.converted_to_confirm_at;

                                    return (
                                      <HoldEvent info={info}
                                                  eventIconPath={eventIconPath}
                                                  canClear={canClearHold(user, info.event.extendedProps)}
                                                  canOpenHoldsOnDate={isActiveAuthorizedHold && holdsOnDate(holdsByDayRef.current, hold).length >= 2}
                                                  canStartChallenge={canManageHoldChallenges && isActiveAuthorizedHold && hasHoldAhead(holdsByDayRef.current, hold)} />
                                    );
                                  }

                                  // Use DayViewConfirmEvent for confirms in day view
                                  if (isDayView) {
                                    return (
                                      <DayViewConfirmEvent info={info}
                                                           team={team}
                                                           eventIconPath={eventIconPath} />
                                    );
                                  }

                                  return (
                                    <ConfirmEvent info={info}
                                                  team={team}
                                                  eventIconPath={eventIconPath} />
                                  );
                                }
                              }
                              eventDidMount={(info) => {
                                if (info.event.extendedProps.is_series_group && info.view.type !== 'dayGridMonth') {
                                  const rowCount = (info.event.extendedProps.grouped_marketing_dates || []).length
                                    + (info.event.extendedProps.venue_name ? 1 : 0);
                                  info.el.style.minHeight =
                                    `${GROUPED_CARD_HEADER_HEIGHT + rowCount * GROUPED_CARD_ROW_HEIGHT}px`;
                                }

                                if(info.event.extendedProps.classification === "confirm"){
                                  const room = info.event.extendedProps.room;
                                  const hexColor = room.calendar_color_hex;

                                  info.el.style.border = `1px solid ${hexColor}`;
                                }

                                if (info.event.extendedProps.type === "Hold"
                                    && info.event.extendedProps.authorized
                                    && !info.event.extendedProps.cleared_at
                                    && !info.event.extendedProps.converted_to_confirm_at
                                    && !info.el.dataset.holdContextBound) {
                                  info.el.dataset.holdContextBound = 'true';
                                  info.el.addEventListener('contextmenu', (e) => {
                                    e.preventDefault();
                                    openHoldsOnDate(info.event.start, info.event.extendedProps.room_id);
                                  });
                                }

                                if (info.event.extendedProps.type === "Hold") {
                                  info.el.dataset.holdPositionId = info.event.extendedProps.hold_position_id;
                                }
                              }}
                              timeZone={"local"}
                              initialView={(currentTeamMembership.calendar_view === "calendar" ? "dayGridMonth" : (currentTeamMembership.calendar_view === "calendar_daily" ? "timeGridDay" : "timeGridWeek"))}
                              eventMinHeight={35}
                              slotEventOverlap={false}
                              eventMaxStack={dynamicEventMaxStack}
                              plugins={[
                                dayGridPlugin,
                                timeGridPlugin,
                                momentTimezonePlugin,
                                interactionPlugin
                              ]} />
              </div>
            ) : isMobile ? (
              <MobileHoldChallengesProvider
                team={team}
                canManageHoldChallenges={Boolean(canManageHoldChallenges)}
                highlightedHoldPositionIds={mobileHighlightedHoldPositionIds}
                onChallengesChanged={refreshChallenges}
              >
                <div className='calendar-view-mobile-list'>
                  {mobileViewMode === 'month' && currentTeamMembership.calendar_mobile_full_view ? (
                    <MobileFullCalendar
                      team={team}
                      dataSource={dataTableDataSource}
                      filters={dataTableFilters}
                      searchTerm={searchTerm}
                      selectedRooms={selectedRooms}
                      weekStartDay={user.calendar_start_day}
                      goToTodaySignal={mobileTodaySignal}
                      goToDate={mobileGoToDate}
                      refreshSignal={mobileRefreshSignal}
                      initialMonth={currentTeamMembership.calendar_starts_at}
                      onMonthChange={setTeamMembershipCurrentDate}
                    />
                  ) : mobileViewMode === 'month' ? (
                    <MobileMonthCalendar
                      team={team}
                      dataSource={dataTableDataSource}
                      filters={dataTableFilters}
                      searchTerm={searchTerm}
                      selectedRooms={selectedRooms}
                      goToTodaySignal={mobileTodaySignal}
                      goToDate={mobileGoToDate}
                      refreshSignal={mobileRefreshSignal}
                      initialMonth={currentTeamMembership.calendar_starts_at}
                      onMonthChange={setTeamMembershipCurrentDate}
                    />
                  ) : (
                    <MobileEventList
                      team={team}
                      dataSource={dataTableDataSource}
                      filters={dataTableFilters}
                      searchTerm={searchTerm}
                      selectedRooms={selectedRooms}
                      refreshSignal={mobileRefreshSignal}
                    />
                  )}
                </div>
              </MobileHoldChallengesProvider>
            ) : (
              <div className='calendar-view-datatable'>
                <DataTable title={dataTableTitle}
                          dataSource={dataTableDataSource}
                          columns={dataTableColumns}
                          reducedFilters={dataTableFilters}
                          searchedSearchTerm={searchTerm}
                          colGroup={
                            <colgroup>
                              <col span={1} style={{"width": "35%"}} />
                              <col span={1} style={{"width": "20%"}} />
                              <col span={1} style={{"width": "10%"}} />
                              <col span={1} style={{"width": "20%"}} />
                              <col span={1} style={{"width": "15%"}} />
                            </colgroup>
                          }
                          onColumnReorder={
                            (e, settings, details) => {
                              var sortDir = details[0].dir;

                              if(sortDir === currentTeamMembership.date_sort_direction){
                                return false;
                              }

                              updateTeamMembershipSetting({ date_sort_direction: sortDir });
                            }
                          }
                          onTableElementSet={
                            (el) => {
                              dataTableElChanged(el);
                            }
                          }
                          createdRow={
                            (row, data, dataIndex) => {
                              $(row).addClass('position-relative');
                            }
                          }
                          order={dataTableOrder} />
              </div>
            )}
            <Popup
              open={calendarEventConflictsModalOpen}
              contentStyle={calendarEventConflictsContentStyle}
              className={"popup-modal"}
              closeOnDocumentClick
              onClose={() => closeCalendarEventConflictsModal()}
            >
              <CalendarEventConflictPopup calendarEventConflicts={calendarEventConflicts}
                                          team={team}
                                          csrfToken={csrfToken}
                                          confirmTeamVenueConflicts={confirmTeamVenueConflicts}
                                          selectedRooms={selectedRooms}
                                          selectedTags={selectedTags}
                                          calendarEventConflictMergeCheckboxClicked={calendarEventConflictMergeCheckboxClicked}
                                          closeModal={closeCalendarEventConflictsModal} />
            </Popup>
            <Popup
              open={checkAvailsIsOpen}
              contentStyle={checkAvailsContentStyle}
              className={"popup-modal"}
              closeOnDocumentClick={true}
              onClose={
                () => {
                  checkAvailsIsOpenChanged(false);
                }
              }>
              <CheckAvailsPopup team={team}
                                checkAvailsIsOpenChanged={checkAvailsIsOpenChanged}
                                checkAvailsSettings={checkAvailsSettings}
                                checkAvailsDates={checkAvailsDates}
                                checkAvailsDatesChanged={checkAvailsDatesChanged}
                                checkAvailsSettingsChanged={checkAvailsSettingsChanged}
                                checkAvailsLoading={checkAvailsLoading}
                                csrfToken={csrfToken}
                                availableDates={getAvailableDates(checkAvailsCalendarEvents, checkAvailsSettings, checkAvailsDates, team.default_top_hold, checkAvailsRooms)}
                                currentTeamMembership={currentTeamMembership}
                                calendarRef={calendarRef.current || {}}
                                rooms={rooms} />
            </Popup>
            <Popup
              open={calendarSyncIsOpen}
              contentStyle={calendarSyncContentStyle}
              className={"popup-modal"}
              closeOnDocumentClick={true}
              onClose={() => { calendarSyncIsOpenChanged(false); }}
            >
              <CalendarSyncPopup
                team={team}
                venueOwnership={venueOwnerships.find((vo) =>
                  vo.room_ids?.includes(selectedRooms[0]?.value)
                )}
                selectedRooms={selectedRooms}
                calendarSyncIsOpenChanged={calendarSyncIsOpenChanged}
              />
            </Popup>
            <KeyboardShortcutsModal
              isOpen={showKeyboardShortcutsModal}
              onClose={() => setShowKeyboardShortcutsModal(false)}
            />
            <GoToDateModal
              isOpen={showGoToDateModal}
              onClose={() => setShowGoToDateModal(false)}
              onGoToDate={(date) => {
                setGoToSpecificDate(date);
                if (calendarRef.current) {
                  calendarRef.current.getApi().gotoDate(date);
                }
              }}
              currentDate={calendarRef.current?.getApi()?.getDate() || new Date()}
            />
          </div>
        </div>
      </div>
      {isMobile && (canCompTickets || conductorEnabled) && (
        <MobileShortcutsButton
          team={team}
          csrfToken={csrfToken}
          canCompTickets={canCompTickets}
          conductorEnabled={conductorEnabled}
        />
      )}
    </div>
  )
};

CalendarViewV2.propTypes = {
  browser: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  venuesOptions: PropTypes.array,
  venueSelected: PropTypes.object,
  venueOwnerships: PropTypes.array,
  updateSelectedVenue: PropTypes.func.isRequired,
  events: PropTypes.array,
  submitNewEventForm: PropTypes.func.isRequired,
  onInit: PropTypes.func.isRequired,
  fetchTeamVenueConflicts: PropTypes.func.isRequired,
  calendarEventConflicts: PropTypes.array,
  calendarEventConflictsModalOpen: PropTypes.bool,
  closeCalendarEventConflictsModal: PropTypes.func.isRequired,
  confirmTeamVenueConflicts: PropTypes.func.isRequired,
  saveUserCalendarStartDay: PropTypes.func.isRequired,
  calendarEventConflictMergeCheckboxClicked: PropTypes.func.isRequired,
  holdGroup: PropTypes.object,
  confirm: PropTypes.object,
  confirmChanged: PropTypes.func.isRequired,
  calendarEventTitle: PropTypes.string,
  updateCalendarEventTitle: PropTypes.func.isRequired,
  calendarEventArtists: PropTypes.array,
  updateCalendarEventArtists: PropTypes.func.isRequired,
  calendarEventType: PropTypes.string,
  updateCalendarEventType: PropTypes.func.isRequired,
  calendarEventTicketForecast: PropTypes.number,
  calendarEventTicketForecastChanged: PropTypes.func.isRequired,
  calendarEventNoteEditorState: PropTypes.object,
  updateCalendarEventNoteEditorState: PropTypes.func.isRequired,
  calendarEventErrors: PropTypes.array,
  calendarEventFormClosed: PropTypes.func.isRequired,
  userChangedCalendarEventTitle: PropTypes.bool,
  onSaleEnabled: PropTypes.bool,
  preSaleEnabled: PropTypes.bool,
  artistPreSaleEnabled: PropTypes.bool,
  announcedEnabled: PropTypes.bool,
  confirmedEnabled: PropTypes.bool,
  holdsEnabled: PropTypes.bool,
  pastEventsEnabled: PropTypes.bool,
  cancelledEventsEnabled: PropTypes.bool,
  toggleOnSaleEnabled: PropTypes.func.isRequired,
  togglePreSaleEnabled: PropTypes.func.isRequired,
  toggleArtistPreSaleEnabled: PropTypes.func.isRequired,
  toggleAnnouncedEnabled: PropTypes.func.isRequired,
  toggleConfirmedEnabled: PropTypes.func.isRequired,
  toggleHoldsEnabled: PropTypes.func.isRequired,
  togglePastEventsEnabled: PropTypes.func.isRequired,
  toggleCancelledEventsEnabled: PropTypes.func.isRequired,
  holdGroupCalendarDateClicked: PropTypes.func.isRequired,
  holdGroupDates: PropTypes.array,
  holdGroupHoldPositionUpdated: PropTypes.func.isRequired,
  holdPositionTargetToggled: PropTypes.func.isRequired,
  holdGroupHoldRemoved: PropTypes.func.isRequired,
  confirmStartDateUpdated: PropTypes.func.isRequired,
  confirmStartTimeUpdated: PropTypes.func.isRequired,
  fetchHoldAvailability: PropTypes.func.isRequired,
  dataTableTitle: PropTypes.string.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  dataTableOrder: PropTypes.array,
  dataTableColumns: PropTypes.array.isRequired,
  dataTableFilters: PropTypes.object,
  reloadDataTable: PropTypes.func.isRequired,
  dataTableEl: PropTypes.object,
  dataTableElChanged: PropTypes.func.isRequired,
  selectedPromoter: PropTypes.object,
  selectedPromoterChanged: PropTypes.func.isRequired,
  buyers: PropTypes.array,
  buyersChanged: PropTypes.func.isRequired,
  promoters: PropTypes.array,
  promotersChanged: PropTypes.func.isRequired,
  selectedBuyer: PropTypes.object,
  selectedBuyerChanged: PropTypes.func.isRequired,
  holdGroupDeletion: PropTypes.object,
  holdGroupDeletionChanged: PropTypes.func.isRequired,
  holdGroupDeletionReasonChanged: PropTypes.func.isRequired,
  holdGroupDeletionExplanationChanged: PropTypes.func.isRequired,
  holdGroupDeletionFollowUpChanged: PropTypes.func.isRequired,
  holdGroupDeletionFollowUpAtChanged: PropTypes.func.isRequired,
  deleteHoldGroup: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  searchTermChanged: PropTypes.func.isRequired,
  currentTeamMembership: PropTypes.object.isRequired,
  saveTeamMembershipCalendarState: PropTypes.func.isRequired,
  submittingForm: PropTypes.bool,
  doorsTimeDefault: PropTypes.object.isRequired,
  eventEndTimeDefault: PropTypes.object.isRequired,
  eventTimeDefaults: PropTypes.object,
  userChangedDoorsTime: PropTypes.bool,
  userChangedDoorsTimeChanged: PropTypes.func.isRequired,
  userChangedEventEndTime: PropTypes.bool,
  userChangedEventEndTimeChanged: PropTypes.func.isRequired,
  applyTimeDefaults: PropTypes.func.isRequired,
  checkAvailsIsOpen: PropTypes.bool,
  checkAvailsIsOpenChanged: PropTypes.func.isRequired,
  checkAvailsSettings: PropTypes.object,
  checkAvailsSettingsChanged: PropTypes.func.isRequired,
  calendarSyncIsOpen: PropTypes.bool,
  calendarSyncIsOpenChanged: PropTypes.func.isRequired,
  checkAvailsDates: PropTypes.array,
  checkAvailsDatesChanged: PropTypes.func.isRequired,
  checkAvailsCalendarEvents: PropTypes.array,
  checkAvailsCalendarEventsChanged: PropTypes.func.isRequired,
  fetchCheckAvailsCalendarEvents: PropTypes.func.isRequired,
  checkAvailsLoadingChanged: PropTypes.func.isRequired,
  checkAvailsLoading: PropTypes.bool,
  holdGroupChanged: PropTypes.func.isRequired,
  fetchCalendarEventsForSelectedVenues: PropTypes.func.isRequired,
  dataTableFiltersChanged: PropTypes.func.isRequired,
  currentTeamMembershipChanged: PropTypes.func.isRequired,
  venueOwnershipsChanged: PropTypes.func.isRequired,
  rooms: PropTypes.array,
  roomsChanged: PropTypes.func.isRequired,
  reorderRooms: PropTypes.func.isRequired,
  canCompTickets: PropTypes.bool,
  conductorEnabled: PropTypes.bool,
  canReadHoldChallenges: PropTypes.bool,
  canManageHoldChallenges: PropTypes.bool,
  reorderHoldPositions: PropTypes.func,
  clearHoldPosition: PropTypes.func.isRequired,
  canManageVenues: PropTypes.bool,
  venueStateOptions: PropTypes.array,
  availableTimezones: PropTypes.array,
};

export default CalendarViewV2;
